/**
 * @license
 * Lo-Dash 2.4.1 (Custom Build) lodash.com/license | Underscore.js 1.5.2 underscorejs.org/LICENSE
 * Build: `lodash underscore exports="amd,commonjs,global,node" -o ./dist/lodash.underscore.js`
 */
;(function(){function n(n,r,t){t=(t||0)-1;for(var e=n?n.length:0;++t<e;)if(n[t]===r)return t;return-1}function r(n,r){for(var t=n.m,e=r.m,u=-1,o=t.length;++u<o;){var i=t[u],f=e[u];if(i!==f){if(i>f||typeof i=="undefined")return 1;if(i<f||typeof f=="undefined")return-1}}return n.n-r.n}function t(n){return"\\"+yr[n]}function e(n,r,t){r||(r=0),typeof t=="undefined"&&(t=n?n.length:0);var e=-1;t=t-r||0;for(var u=Array(0>t?0:t);++e<t;)u[e]=n[r+e];return u}function u(n){return n instanceof u?n:new o(n)}function o(n,r){this.__chain__=!!r,this.__wrapped__=n
}function i(n){function r(){if(u){var n=e(u);Rr.apply(n,arguments)}if(this instanceof r){var i=f(t.prototype),n=t.apply(i,n||arguments);return O(n)?n:i}return t.apply(o,n||arguments)}var t=n[0],u=n[2],o=n[4];return r}function f(n){return O(n)?Br(n):{}}function a(n,r,t){if(typeof n!="function")return Y;if(typeof r=="undefined"||!("prototype"in n))return n;switch(t){case 1:return function(t){return n.call(r,t)};case 2:return function(t,e){return n.call(r,t,e)};case 3:return function(t,e,u){return n.call(r,t,e,u)
};case 4:return function(t,e,u,o){return n.call(r,t,e,u,o)}}return L(n,r)}function l(n){function r(){var n=p?a:this;if(o){var y=e(o);Rr.apply(y,arguments)}return(i||g)&&(y||(y=e(arguments)),i&&Rr.apply(y,i),g&&y.length<c)?(u|=16,l([t,h?u:-4&u,y,null,a,c])):(y||(y=arguments),s&&(t=n[v]),this instanceof r?(n=f(t.prototype),y=t.apply(n,y),O(y)?y:n):t.apply(n,y))}var t=n[0],u=n[1],o=n[2],i=n[3],a=n[4],c=n[5],p=1&u,s=2&u,g=4&u,h=8&u,v=t;return r}function c(n,r){for(var t=-1,e=m(),u=n?n.length:0,o=[];++t<u;){var i=n[t];
0>e(r,i)&&o.push(i)}return o}function p(n,r,t,e){e=(e||0)-1;for(var u=n?n.length:0,o=[];++e<u;){var i=n[e];if(i&&typeof i=="object"&&typeof i.length=="number"&&(Cr(i)||b(i))){r||(i=p(i,r,t));var f=-1,a=i.length,l=o.length;for(o.length+=a;++f<a;)o[l++]=i[f]}else t||o.push(i)}return o}function s(n,r,t,e){if(n===r)return 0!==n||1/n==1/r;if(n===n&&!(n&&vr[typeof n]||r&&vr[typeof r]))return false;if(null==n||null==r)return n===r;var o=Er.call(n),i=Er.call(r);if(o!=i)return false;switch(o){case lr:case cr:return+n==+r;
case pr:return n!=+n?r!=+r:0==n?1/n==1/r:n==+r;case gr:case hr:return n==r+""}if(i=o==ar,!i){var f=n instanceof u,a=r instanceof u;if(f||a)return s(f?n.__wrapped__:n,a?r.__wrapped__:r,t,e);if(o!=sr)return false;if(o=n.constructor,f=r.constructor,o!=f&&!(A(o)&&o instanceof o&&A(f)&&f instanceof f)&&"constructor"in n&&"constructor"in r)return false}for(t||(t=[]),e||(e=[]),o=t.length;o--;)if(t[o]==n)return e[o]==r;var l=true,c=0;if(t.push(n),e.push(r),i){if(c=r.length,l=c==n.length)for(;c--&&(l=s(n[c],r[c],t,e)););}else Kr(r,function(r,u,o){return Nr.call(o,u)?(c++,!(l=Nr.call(n,u)&&s(n[u],r,t,e))&&er):void 0
}),l&&Kr(n,function(n,r,t){return Nr.call(t,r)?!(l=-1<--c)&&er:void 0});return t.pop(),e.pop(),l}function g(n,r,t){for(var e=-1,u=m(),o=n?n.length:0,i=[],f=t?[]:i;++e<o;){var a=n[e],l=t?t(a,e,n):a;(r?!e||f[f.length-1]!==l:0>u(f,l))&&(t&&f.push(l),i.push(a))}return i}function h(n){return function(r,t,e){var u={};t=X(t,e,3),e=-1;var o=r?r.length:0;if(typeof o=="number")for(;++e<o;){var i=r[e];n(u,i,t(i,e,r),r)}else Lr(r,function(r,e,o){n(u,r,t(r,e,o),o)});return u}}function v(n,r,t,e,u,o){var f=16&r,a=32&r;
if(!(2&r||A(n)))throw new TypeError;return f&&!t.length&&(r&=-17,t=false),a&&!e.length&&(r&=-33,e=false),(1==r||17===r?i:l)([n,r,t,e,u,o])}function y(n){return Vr[n]}function m(){var r=(r=u.indexOf)===G?n:r;return r}function _(n){return typeof n=="function"&&Ar.test(n)}function d(n){return Gr[n]}function b(n){return n&&typeof n=="object"&&typeof n.length=="number"&&Er.call(n)==fr||false}function w(n){if(!n)return n;for(var r=1,t=arguments.length;r<t;r++){var e=arguments[r];if(e)for(var u in e)n[u]=e[u]}return n
}function j(n){if(!n)return n;for(var r=1,t=arguments.length;r<t;r++){var e=arguments[r];if(e)for(var u in e)"undefined"==typeof n[u]&&(n[u]=e[u])}return n}function x(n){var r=[];return Kr(n,function(n,t){A(n)&&r.push(t)}),r.sort()}function T(n){for(var r=-1,t=Ur(n),e=t.length,u={};++r<e;){var o=t[r];u[n[o]]=o}return u}function E(n){if(!n)return true;if(Cr(n)||N(n))return!n.length;for(var r in n)if(Nr.call(n,r))return false;return true}function A(n){return typeof n=="function"}function O(n){return!(!n||!vr[typeof n])
}function S(n){return typeof n=="number"||n&&typeof n=="object"&&Er.call(n)==pr||false}function N(n){return typeof n=="string"||n&&typeof n=="object"&&Er.call(n)==hr||false}function R(n){for(var r=-1,t=Ur(n),e=t.length,u=Array(e);++r<e;)u[r]=n[t[r]];return u}function k(n,r){var t=m(),e=n?n.length:0,u=false;return e&&typeof e=="number"?u=-1<t(n,r):Lr(n,function(n){return(u=n===r)&&er}),u}function B(n,r,t){var e=true;r=X(r,t,3),t=-1;var u=n?n.length:0;if(typeof u=="number")for(;++t<u&&(e=!!r(n[t],t,n)););else Lr(n,function(n,t,u){return!(e=!!r(n,t,u))&&er
});return e}function F(n,r,t){var e=[];r=X(r,t,3),t=-1;var u=n?n.length:0;if(typeof u=="number")for(;++t<u;){var o=n[t];r(o,t,n)&&e.push(o)}else Lr(n,function(n,t,u){r(n,t,u)&&e.push(n)});return e}function q(n,r,t){r=X(r,t,3),t=-1;var e=n?n.length:0;if(typeof e!="number"){var u;return Lr(n,function(n,t,e){return r(n,t,e)?(u=n,er):void 0}),u}for(;++t<e;){var o=n[t];if(r(o,t,n))return o}}function D(n,r,t){var e=-1,u=n?n.length:0;if(r=r&&typeof t=="undefined"?r:a(r,t,3),typeof u=="number")for(;++e<u&&r(n[e],e,n)!==er;);else Lr(n,r)
}function I(n,r){var t=n?n.length:0;if(typeof t=="number")for(;t--&&false!==r(n[t],t,n););else{var e=Ur(n),t=e.length;Lr(n,function(n,u,o){return u=e?e[--t]:--t,false===r(o[u],u,o)&&er})}}function M(n,r,t){var e=-1,u=n?n.length:0;if(r=X(r,t,3),typeof u=="number")for(var o=Array(u);++e<u;)o[e]=r(n[e],e,n);else o=[],Lr(n,function(n,t,u){o[++e]=r(n,t,u)});return o}function $(n,r,t){var e=-1/0,u=e;typeof r!="function"&&t&&t[r]===n&&(r=null);var o=-1,i=n?n.length:0;if(null==r&&typeof i=="number")for(;++o<i;)t=n[o],t>u&&(u=t);
else r=X(r,t,3),D(n,function(n,t,o){t=r(n,t,o),t>e&&(e=t,u=n)});return u}function W(n,r,t,e){if(!n)return t;var u=3>arguments.length;r=X(r,e,4);var o=-1,i=n.length;if(typeof i=="number")for(u&&(t=n[++o]);++o<i;)t=r(t,n[o],o,n);else Lr(n,function(n,e,o){t=u?(u=false,n):r(t,n,e,o)});return t}function z(n,r,t,e){var u=3>arguments.length;return r=X(r,e,4),I(n,function(n,e,o){t=u?(u=false,n):r(t,n,e,o)}),t}function C(n){var r=-1,t=n?n.length:0,e=Array(typeof t=="number"?t:0);return D(n,function(n){var t;t=++r,t=0+Sr(Wr()*(t-0+1)),e[r]=e[t],e[t]=n
}),e}function P(n,r,t){var e;r=X(r,t,3),t=-1;var u=n?n.length:0;if(typeof u=="number")for(;++t<u&&!(e=r(n[t],t,n)););else Lr(n,function(n,t,u){return(e=r(n,t,u))&&er});return!!e}function U(n,r,t){return t&&E(r)?rr:(t?q:F)(n,r)}function V(n,r,t){var u=0,o=n?n.length:0;if(typeof r!="number"&&null!=r){var i=-1;for(r=X(r,t,3);++i<o&&r(n[i],i,n);)u++}else if(u=r,null==u||t)return n?n[0]:rr;return e(n,0,$r(Mr(0,u),o))}function G(r,t,e){if(typeof e=="number"){var u=r?r.length:0;e=0>e?Mr(0,u+e):e||0}else if(e)return e=J(r,t),r[e]===t?e:-1;
return n(r,t,e)}function H(n,r,t){if(typeof r!="number"&&null!=r){var u=0,o=-1,i=n?n.length:0;for(r=X(r,t,3);++o<i&&r(n[o],o,n);)u++}else u=null==r||t?1:Mr(0,r);return e(n,u)}function J(n,r,t,e){var u=0,o=n?n.length:u;for(t=t?X(t,e,1):Y,r=t(r);u<o;)e=u+o>>>1,t(n[e])<r?u=e+1:o=e;return u}function K(n,r,t,e){return typeof r!="boolean"&&null!=r&&(e=t,t=typeof r!="function"&&e&&e[r]===n?null:r,r=false),null!=t&&(t=X(t,e,3)),g(n,r,t)}function L(n,r){return 2<arguments.length?v(n,17,e(arguments,2),null,r):v(n,1,null,null,r)
}function Q(n,r,t){var e,u,o,i,f,a,l,c=0,p=false,s=true;if(!A(n))throw new TypeError;if(r=Mr(0,r)||0,true===t)var g=true,s=false;else O(t)&&(g=t.leading,p="maxWait"in t&&(Mr(r,t.maxWait)||0),s="trailing"in t?t.trailing:s);var h=function(){var t=r-(nt()-i);0<t?a=setTimeout(h,t):(u&&clearTimeout(u),t=l,u=a=l=rr,t&&(c=nt(),o=n.apply(f,e),a||u||(e=f=null)))},v=function(){a&&clearTimeout(a),u=a=l=rr,(s||p!==r)&&(c=nt(),o=n.apply(f,e),a||u||(e=f=null))};return function(){if(e=arguments,i=nt(),f=this,l=s&&(a||!g),false===p)var t=g&&!a;
else{u||g||(c=i);var y=p-(i-c),m=0>=y;m?(u&&(u=clearTimeout(u)),c=i,o=n.apply(f,e)):u||(u=setTimeout(v,y))}return m&&a?a=clearTimeout(a):a||r===p||(a=setTimeout(h,r)),t&&(m=true,o=n.apply(f,e)),!m||a||u||(e=f=null),o}}function X(n,r,t){var e=typeof n;if(null==n||"function"==e)return a(n,r,t);if("object"!=e)return nr(n);var u=Ur(n);return function(r){for(var t=u.length,e=false;t--&&(e=r[u[t]]===n[u[t]]););return e}}function Y(n){return n}function Z(n){D(x(n),function(r){var t=u[r]=n[r];u.prototype[r]=function(){var n=[this.__wrapped__];
return Rr.apply(n,arguments),n=t.apply(u,n),this.__chain__?new o(n,true):n}})}function nr(n){return function(r){return r[n]}}var rr,tr=0,er={},ur=+new Date+"",or=/($^)/,ir=/['\n\r\t\u2028\u2029\\]/g,fr="[object Arguments]",ar="[object Array]",lr="[object Boolean]",cr="[object Date]",pr="[object Number]",sr="[object Object]",gr="[object RegExp]",hr="[object String]",vr={"boolean":false,"function":true,object:true,number:false,string:false,undefined:false},yr={"\\":"\\","'":"'","\n":"n","\r":"r","\t":"t","\u2028":"u2028","\u2029":"u2029"},mr=vr[typeof window]&&window||this,_r=vr[typeof exports]&&exports&&!exports.nodeType&&exports,dr=vr[typeof module]&&module&&!module.nodeType&&module,br=dr&&dr.exports===_r&&_r,wr=vr[typeof global]&&global;
!wr||wr.global!==wr&&wr.window!==wr||(mr=wr);var jr=[],xr=Object.prototype,Tr=mr._,Er=xr.toString,Ar=RegExp("^"+(Er+"").replace(/[.*+?^${}()|[\]\\]/g,"\\$&").replace(/toString| for [^\]]+/g,".*?")+"$"),Or=Math.ceil,Sr=Math.floor,Nr=xr.hasOwnProperty,Rr=jr.push,kr=xr.propertyIsEnumerable,Br=_(Br=Object.create)&&Br,Fr=_(Fr=Array.isArray)&&Fr,qr=mr.isFinite,Dr=mr.isNaN,Ir=_(Ir=Object.keys)&&Ir,Mr=Math.max,$r=Math.min,Wr=Math.random;o.prototype=u.prototype;var zr={};!function(){var n={0:1,length:1};zr.spliceObjects=(jr.splice.call(n,0,1),!n[0])
}(1),u.templateSettings={escape:/<%-([\s\S]+?)%>/g,evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,variable:""},Br||(f=function(){function n(){}return function(r){if(O(r)){n.prototype=r;var t=new n;n.prototype=null}return t||mr.Object()}}()),b(arguments)||(b=function(n){return n&&typeof n=="object"&&typeof n.length=="number"&&Nr.call(n,"callee")&&!kr.call(n,"callee")||false});var Cr=Fr||function(n){return n&&typeof n=="object"&&typeof n.length=="number"&&Er.call(n)==ar||false},Pr=function(n){var r,t=[];
if(!n||!vr[typeof n])return t;for(r in n)Nr.call(n,r)&&t.push(r);return t},Ur=Ir?function(n){return O(n)?Ir(n):[]}:Pr,Vr={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"},Gr=T(Vr),Hr=RegExp("("+Ur(Gr).join("|")+")","g"),Jr=RegExp("["+Ur(Vr).join("")+"]","g"),Kr=function(n,r){var t;if(!n||!vr[typeof n])return n;for(t in n)if(r(n[t],t,n)===er)break;return n},Lr=function(n,r){var t;if(!n||!vr[typeof n])return n;for(t in n)if(Nr.call(n,t)&&r(n[t],t,n)===er)break;return n};A(/x/)&&(A=function(n){return typeof n=="function"&&"[object Function]"==Er.call(n)
});var Qr=h(function(n,r,t){Nr.call(n,t)?n[t]++:n[t]=1}),Xr=h(function(n,r,t){(Nr.call(n,t)?n[t]:n[t]=[]).push(r)}),Yr=h(function(n,r,t){n[t]=r}),Zr=M,nt=_(nt=Date.now)&&nt||function(){return(new Date).getTime()};u.after=function(n,r){if(!A(r))throw new TypeError;return function(){return 1>--n?r.apply(this,arguments):void 0}},u.bind=L,u.bindAll=function(n){for(var r=1<arguments.length?p(arguments,true,false,1):x(n),t=-1,e=r.length;++t<e;){var u=r[t];n[u]=v(n[u],1,null,null,n)}return n},u.chain=function(n){return n=new o(n),n.__chain__=true,n
},u.compact=function(n){for(var r=-1,t=n?n.length:0,e=[];++r<t;){var u=n[r];u&&e.push(u)}return e},u.compose=function(){for(var n=arguments,r=n.length;r--;)if(!A(n[r]))throw new TypeError;return function(){for(var r=arguments,t=n.length;t--;)r=[n[t].apply(this,r)];return r[0]}},u.countBy=Qr,u.debounce=Q,u.defaults=j,u.defer=function(n){if(!A(n))throw new TypeError;var r=e(arguments,1);return setTimeout(function(){n.apply(rr,r)},1)},u.delay=function(n,r){if(!A(n))throw new TypeError;var t=e(arguments,2);
return setTimeout(function(){n.apply(rr,t)},r)},u.difference=function(n){return c(n,p(arguments,true,true,1))},u.filter=F,u.flatten=function(n,r){return p(n,r)},u.forEach=D,u.functions=x,u.groupBy=Xr,u.indexBy=Yr,u.initial=function(n,r,t){var u=0,o=n?n.length:0;if(typeof r!="number"&&null!=r){var i=o;for(r=X(r,t,3);i--&&r(n[i],i,n);)u++}else u=null==r||t?1:r||u;return e(n,0,$r(Mr(0,o-u),o))},u.intersection=function(){for(var n=[],r=-1,t=arguments.length;++r<t;){var e=arguments[r];(Cr(e)||b(e))&&n.push(e)
}var u=n[0],o=-1,i=m(),f=u?u.length:0,a=[];n:for(;++o<f;)if(e=u[o],0>i(a,e)){for(r=t;--r;)if(0>i(n[r],e))continue n;a.push(e)}return a},u.invert=T,u.invoke=function(n,r){var t=e(arguments,2),u=-1,o=typeof r=="function",i=n?n.length:0,f=Array(typeof i=="number"?i:0);return D(n,function(n){f[++u]=(o?r:n[r]).apply(n,t)}),f},u.keys=Ur,u.map=M,u.max=$,u.memoize=function(n,r){var t={};return function(){var e=r?r.apply(this,arguments):ur+arguments[0];return Nr.call(t,e)?t[e]:t[e]=n.apply(this,arguments)
}},u.min=function(n,r,t){var e=1/0,u=e;typeof r!="function"&&t&&t[r]===n&&(r=null);var o=-1,i=n?n.length:0;if(null==r&&typeof i=="number")for(;++o<i;)t=n[o],t<u&&(u=t);else r=X(r,t,3),D(n,function(n,t,o){t=r(n,t,o),t<e&&(e=t,u=n)});return u},u.omit=function(n){var r=[];Kr(n,function(n,t){r.push(t)});for(var r=c(r,p(arguments,true,false,1)),t=-1,e=r.length,u={};++t<e;){var o=r[t];u[o]=n[o]}return u},u.once=function(n){var r,t;if(!A(n))throw new TypeError;return function(){return r?t:(r=true,t=n.apply(this,arguments),n=null,t)
}},u.pairs=function(n){for(var r=-1,t=Ur(n),e=t.length,u=Array(e);++r<e;){var o=t[r];u[r]=[o,n[o]]}return u},u.partial=function(n){return v(n,16,e(arguments,1))},u.pick=function(n){for(var r=-1,t=p(arguments,true,false,1),e=t.length,u={};++r<e;){var o=t[r];o in n&&(u[o]=n[o])}return u},u.pluck=Zr,u.range=function(n,r,t){n=+n||0,t=+t||1,null==r&&(r=n,n=0);var e=-1;r=Mr(0,Or((r-n)/t));for(var u=Array(r);++e<r;)u[e]=n,n+=t;return u},u.reject=function(n,r,t){return r=X(r,t,3),F(n,function(n,t,e){return!r(n,t,e)
})},u.rest=H,u.shuffle=C,u.sortBy=function(n,t,e){var u=-1,o=n?n.length:0,i=Array(typeof o=="number"?o:0);for(t=X(t,e,3),D(n,function(n,r,e){i[++u]={m:[t(n,r,e)],n:u,o:n}}),o=i.length,i.sort(r);o--;)i[o]=i[o].o;return i},u.tap=function(n,r){return r(n),n},u.throttle=function(n,r,t){var e=true,u=true;if(!A(n))throw new TypeError;return false===t?e=false:O(t)&&(e="leading"in t?t.leading:e,u="trailing"in t?t.trailing:u),t={},t.leading=e,t.maxWait=r,t.trailing=u,Q(n,r,t)},u.times=function(n,r,t){n=-1<(n=+n)?n:0;
var e=-1,u=Array(n);for(r=a(r,t,1);++e<n;)u[e]=r(e);return u},u.toArray=function(n){return Cr(n)?e(n):n&&typeof n.length=="number"?M(n):R(n)},u.union=function(){return g(p(arguments,true,true))},u.uniq=K,u.values=R,u.where=U,u.without=function(n){return c(n,e(arguments,1))},u.wrap=function(n,r){return v(r,16,[n])},u.zip=function(){for(var n=-1,r=$(Zr(arguments,"length")),t=Array(0>r?0:r);++n<r;)t[n]=Zr(arguments,n);return t},u.collect=M,u.drop=H,u.each=D,u.extend=w,u.methods=x,u.object=function(n,r){var t=-1,e=n?n.length:0,u={};
for(r||!e||Cr(n[0])||(r=[]);++t<e;){var o=n[t];r?u[o]=r[t]:o&&(u[o[0]]=o[1])}return u},u.select=F,u.tail=H,u.unique=K,u.clone=function(n){return O(n)?Cr(n)?e(n):w({},n):n},u.contains=k,u.escape=function(n){return null==n?"":(n+"").replace(Jr,y)},u.every=B,u.find=q,u.has=function(n,r){return n?Nr.call(n,r):false},u.identity=Y,u.indexOf=G,u.isArguments=b,u.isArray=Cr,u.isBoolean=function(n){return true===n||false===n||n&&typeof n=="object"&&Er.call(n)==lr||false},u.isDate=function(n){return n&&typeof n=="object"&&Er.call(n)==cr||false
},u.isElement=function(n){return n&&1===n.nodeType||false},u.isEmpty=E,u.isEqual=function(n,r){return s(n,r)},u.isFinite=function(n){return qr(n)&&!Dr(parseFloat(n))},u.isFunction=A,u.isNaN=function(n){return S(n)&&n!=+n},u.isNull=function(n){return null===n},u.isNumber=S,u.isObject=O,u.isRegExp=function(n){return n&&vr[typeof n]&&Er.call(n)==gr||false},u.isString=N,u.isUndefined=function(n){return typeof n=="undefined"},u.lastIndexOf=function(n,r,t){var e=n?n.length:0;for(typeof t=="number"&&(e=(0>t?Mr(0,e+t):$r(t,e-1))+1);e--;)if(n[e]===r)return e;
return-1},u.mixin=Z,u.noConflict=function(){return mr._=Tr,this},u.random=function(n,r){return null==n&&null==r&&(r=1),n=+n||0,null==r?(r=n,n=0):r=+r||0,n+Sr(Wr()*(r-n+1))},u.reduce=W,u.reduceRight=z,u.result=function(n,r){if(n){var t=n[r];return A(t)?n[r]():t}},u.size=function(n){var r=n?n.length:0;return typeof r=="number"?r:Ur(n).length},u.some=P,u.sortedIndex=J,u.template=function(n,r,e){var o=u,i=o.templateSettings;n=(n||"")+"",e=j({},e,i);var f=0,a="__p+='",i=e.variable;n.replace(RegExp((e.escape||or).source+"|"+(e.interpolate||or).source+"|"+(e.evaluate||or).source+"|$","g"),function(r,e,u,o,i){return a+=n.slice(f,i).replace(ir,t),e&&(a+="'+_.escape("+e+")+'"),o&&(a+="';"+o+";\n__p+='"),u&&(a+="'+((__t=("+u+"))==null?'':__t)+'"),f=i+r.length,r
}),a+="';",i||(i="obj",a="with("+i+"||{}){"+a+"}"),a="function("+i+"){var __t,__p='',__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}"+a+"return __p}";try{var l=Function("_","return "+a)(o)}catch(c){throw c.source=a,c}return r?l(r):(l.source=a,l)},u.unescape=function(n){return null==n?"":(n+"").replace(Hr,d)},u.uniqueId=function(n){var r=++tr+"";return n?n+r:r},u.all=B,u.any=P,u.detect=q,u.findWhere=function(n,r){return U(n,r,true)},u.foldl=W,u.foldr=z,u.include=k,u.inject=W,u.first=V,u.last=function(n,r,t){var u=0,o=n?n.length:0;
if(typeof r!="number"&&null!=r){var i=o;for(r=X(r,t,3);i--&&r(n[i],i,n);)u++}else if(u=r,null==u||t)return n?n[o-1]:rr;return e(n,Mr(0,o-u))},u.sample=function(n,r,t){return n&&typeof n.length!="number"&&(n=R(n)),null==r||t?n?n[0+Sr(Wr()*(n.length-1-0+1))]:rr:(n=C(n),n.length=$r(Mr(0,r),n.length),n)},u.take=V,u.head=V,Z(u),u.VERSION="2.4.1",u.prototype.chain=function(){return this.__chain__=true,this},u.prototype.value=function(){return this.__wrapped__},D("pop push reverse shift sort splice unshift".split(" "),function(n){var r=jr[n];
u.prototype[n]=function(){var n=this.__wrapped__;return r.apply(n,arguments),zr.spliceObjects||0!==n.length||delete n[0],this}}),D(["concat","join","slice"],function(n){var r=jr[n];u.prototype[n]=function(){var n=r.apply(this.__wrapped__,arguments);return this.__chain__&&(n=new o(n),n.__chain__=true),n}}),typeof define=="function"&&typeof define.amd=="object"&&define.amd?(mr._=u, define(function(){return u})):_r&&dr?br?(dr.exports=u)._=u:_r._=u:mr._=u}).call(this);

//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore');
    factory(root, exports, _);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

if (typeof hubspot !== "undefined" && hubspot.define) {
  hubspot.define('backbone', [], function() { return window.Backbone; });
  hubspot.define('Backbone', [], function() { return window.Backbone; });
}


(function (root, factory) {
   if (typeof exports === 'object' && root.require) {
     module.exports = factory(require("underscore"), require("backbone"));
   } else if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["underscore","backbone"], function(_, Backbone) {
        // Use global variables if the locals are undefined.
        return factory(_ || root._, Backbone || root.Backbone);
      });
   } else {
      // RequireJS isn't being used. Assume underscore and backbone are loaded in <script> tags
      factory(_, Backbone);
   }
}(this, function(_, Backbone) {

var queryStringParam = /^\?(.*)/,
    optionalParam = /\((.*?)\)/g,
    namedParam    = /(\(\?)?:\w+/g,
    splatParam    = /\*\w+/g,
    escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g,
    fragmentStrip = /^([^\?]*)/,
    namesPattern = /[\:\*]([^\:\?\/]+)/g,
    routeStripper = /^[#\/]|\s+$/g,
    trailingSlash = /\/$/;
Backbone.Router.arrayValueSplit = '|';

_.extend(Backbone.History.prototype, {
  getFragment: function(fragment, forcePushState) {
    /*jshint eqnull:true */
    if (fragment == null) {
      if (this._hasPushState || !this._wantsHashChange || forcePushState) {
        fragment = this.location.pathname;
        var root = this.root.replace(trailingSlash, '');
        var search = this.location.search;
        if (!fragment.indexOf(root)) {
          fragment = fragment.substr(root.length);
        }
        if (search && this._hasPushState) {
          fragment += search;
        }
      } else {
        fragment = this.getHash();
      }
    }
    return fragment.replace(routeStripper, '');
  },

  // this will not perform custom query param serialization specific to the router
  // but will return a map of key/value pairs (the value is a string or array)
  getQueryParameters: function(fragment, forcePushState) {
    fragment = this.getFragment(fragment, forcePushState);
    // if no query string exists, this will still be the original fragment
    var queryString = fragment.replace(fragmentStrip, '');
    var match = queryString.match(queryStringParam);
    if (match) {
      queryString = match[1];
      var rtn = {};
      iterateQueryString(queryString, function(name, value) {
        value = parseParams(value);

        if (!rtn[name]) {
          rtn[name] = value;
        } else if (_.isString(rtn[name])) {
          rtn[name] = [rtn[name], value];
        } else {
          rtn[name].push(value);
        }
      });
      return rtn;
    } else {
      // no values
      return {};
    }
  }
});

_.extend(Backbone.Router.prototype, {
  initialize: function(options) {
    this.encodedSplatParts = options && options.encodedSplatParts;
  },

  _routeToRegExp: function(route) {
    var splatMatch = (splatParam.exec(route) || {index: -1}),
        namedMatch = (namedParam.exec(route) || {index: -1}),
        paramNames = route.match(namesPattern) || [];

    route = route.replace(escapeRegExp, '\\$&')
                 .replace(optionalParam, '(?:$1)?')
                 .replace(namedParam, function(match, optional){
                   return optional ? match : '([^\\/\\?]+)';
                 })
                 // `[^??]` is hacking around a regular expression bug under iOS4.
                 // If only `[^?]` is used then paths like signin/photos will fail
                 // while paths with `?` anywhere, like `signin/photos?`, will succeed.
                 .replace(splatParam, '([^??]*?)');
    route += '(\\?.*)?';
    var rtn = new RegExp('^' + route + '$');

    // use the rtn value to hold some parameter data
    if (splatMatch.index >= 0) {
      // there is a splat
      if (namedMatch >= 0) {
        // negative value will indicate there is a splat match before any named matches
        rtn.splatMatch = splatMatch.index - namedMatch.index;
      } else {
        rtn.splatMatch = -1;
      }
    }
    rtn.paramNames = _.map(paramNames, function(name) { return name.substring(1); });
    rtn.namedParameters = this.namedParameters;

    return rtn;
  },

  /**
   * Given a route, and a URL fragment that it matches, return the array of
   * extracted parameters.
   */
  _extractParameters: function(route, fragment) {
    var params = route.exec(fragment).slice(1),
        namedParams = {};
    if (params.length > 0 && _.isUndefined(params[params.length - 1])) {
      // remove potential invalid data from query params match
      params.splice(params.length - 1, 1);
    }

    // do we have an additional query string?
    var match = params.length && params[params.length-1] && params[params.length-1].match(queryStringParam);
    if (match) {
      var queryString = match[1];
      var data = {};
      if (queryString) {
        var self = this;
        iterateQueryString(queryString, function(name, value) {
          self._setParamValue(name, value, data);
        });
      }
      params[params.length-1] = data;
      _.extend(namedParams, data);
    }

    // decode params
    var length = params.length;
    if (route.splatMatch && this.encodedSplatParts) {
      if (route.splatMatch < 0) {
        // splat param is first
        return params;
      } else {
        length = length - 1;
      }
    }

    for (var i=0; i<length; i++) {
      if (_.isString(params[i])) {
        params[i] = parseParams(params[i]);
        if (route.paramNames && route.paramNames.length >= i-1) {
          namedParams[route.paramNames[i]] = params[i];
        }
      }
    }

    return (Backbone.Router.namedParameters || route.namedParameters) ? [namedParams] : params;
  },

  /**
   * Set the parameter value on the data hash
   */
  _setParamValue: function(key, value, data) {
    // use '.' to define hash separators
    key = key.replace('[]', '');
    key = key.replace('%5B%5D', '');
    var parts = key.split('.');
    var _data = data;
    for (var i=0; i<parts.length; i++) {
      var part = parts[i];
      if (i === parts.length-1) {
        // set the value
        _data[part] = this._decodeParamValue(value, _data[part]);
      } else {
        _data = _data[part] = _data[part] || {};
      }
    }
  },

  /**
   * Decode an individual parameter value (or list of values)
   * @param value the complete value
   * @param currentValue the currently known value (or list of values)
   */
  _decodeParamValue: function(value, currentValue) {
    // '|' will indicate an array.  Array with 1 value is a=|b - multiple values can be a=b|c
    var splitChar = Backbone.Router.arrayValueSplit;
    if (splitChar && value.indexOf(splitChar) >= 0) {
      var values = value.split(splitChar);
      // clean it up
      for (var i=values.length-1; i>=0; i--) {
        if (!values[i]) {
          values.splice(i, 1);
        } else {
          values[i] = parseParams(values[i]);
        }
      }
      return values;
    }

    value = parseParams(value);
    if (!currentValue) {
      return value;
    } else if (_.isArray(currentValue)) {
      currentValue.push(value);
      return currentValue;
    } else {
      return [currentValue, value];
    }
  },

  /**
   * Return the route fragment with queryParameters serialized to query parameter string
   */
  toFragment: function(route, queryParameters) {
    if (queryParameters) {
      if (!_.isString(queryParameters)) {
        queryParameters = toQueryString(queryParameters);
      }
      if(queryParameters) {
        route += '?' + queryParameters;
      }
    }
    return route;
  }
});


/**
 * Serialize the val hash to query parameters and return it.  Use the namePrefix to prefix all param names (for recursion)
 */
function toQueryString(val, namePrefix) {
  /*jshint eqnull:true */
  var splitChar = Backbone.Router.arrayValueSplit;
  function encodeSplit(val) { return String(val).replace(splitChar, encodeURIComponent(splitChar)); }

  if (!val) {
    return '';
  }

  namePrefix = namePrefix || '';
  var rtn = [];
  _.each(val, function(_val, name) {
    name = namePrefix + name;

    if (_.isString(_val) || _.isNumber(_val) || _.isBoolean(_val) || _.isDate(_val)) {
      // primitive type
      if (_val != null) {
        rtn.push(name + '=' + encodeSplit(encodeURIComponent(_val)));
      }
    } else if (_.isArray(_val)) {
      // arrays use Backbone.Router.arrayValueSplit separator
      var str = '';
      for (var i = 0; i < _val.length; i++) {
        var param = _val[i];
        if (param != null) {
          str += splitChar + encodeSplit(param);
        }
      }
      if (str) {
        rtn.push(name + '=' + str);
      }
    } else {
      // dig into hash
      var result = toQueryString(_val, name + '.');
      if (result) {
        rtn.push(result);
      }
    }
  });

  return rtn.join('&');
}

function parseParams(value) {
  // decodeURIComponent doesn't touch '+'
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch (err) {
    // Failover to whatever was passed if we get junk data
    return value;
  }
}

function iterateQueryString(queryString, callback) {
  var keyValues = queryString.split('&');
  _.each(keyValues, function(keyValue) {
    var arr = keyValue.split('=');
    callback(arr.shift(), arr.join('='));
  });
}

}));


//
// Works around issue introduced in Backbone 1.1 by https://github.com/jashkenas/backbone/pull/2766
//
// This file is unnecessary under Backbone 1.0 and earlier.
//
// Note that https://github.com/jashkenas/backbone/pull/2890 should hopefully make this irrevelant
//
Backbone.History.prototype.navigate = function(fragment, options) {
  /*jshint curly:false */
  if (!Backbone.History.started) return false;
  if (!options || options === true) options = {trigger: !!options};

  var url = this.root + (fragment = this.getFragment(fragment || ''));

  // Removed from the upstream impl:
  // Strip the fragment of the query and hash for matching.
  // fragment = fragment.replace(pathStripper, '');

  if (this.fragment === fragment) return;
  this.fragment = fragment;

  // Don't include a trailing slash on the root.
  if (fragment === '' && url !== '/') url = url.slice(0, -1);

  // If pushState is available, we use it to set the fragment as a real URL.
  if (this._hasPushState) {
    this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

  // If hash changes haven't been explicitly disabled, update the hash
  // fragment to store history.
  } else if (this._wantsHashChange) {
    this._updateHash(this.location, fragment, options.replace);
    if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
      // Opening and closing the iframe tricks IE7 and earlier to push a
      // history entry on hash-tag change.  When replace is true, we don't
      // want this.
      if(!options.replace) this.iframe.document.open().close();
      this._updateHash(this.iframe.location, fragment, options.replace);
    }

  // If you've told us that you explicitly don't want fallback hashchange-
  // based history, then `navigate` becomes a page refresh.
  } else {
    return this.location.assign(url);
  }
  if (options.trigger) return this.loadUrl(fragment);
};


(function () {
var arrayIndex, isArray, isFinite, isNaN, isNumber, nativeTrim, objectRef, sortedIndex, timeFormats, toString;

objectRef = new function() {};

toString = objectRef.toString;

sortedIndex = function(array, candidate, iterator) {
  var high, low, mid, value;
  if (iterator == null) {
    iterator = function(value) {
      return value;
    };
  }
  value = iterator(candidate);
  low = 0;
  high = array.length;
  while (low < high) {
    mid = (low + high) >> 1;
    if (iterator(array[mid]) < value) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
};

arrayIndex = [].indexOf || function(item) {
  var arr, arrItem, index, j, len1;
  arr = this;
  for (index = j = 0, len1 = arr.length; j < len1; index = ++j) {
    arrItem = arr[index];
    if (arrItem === item) {
      return index;
    }
  }
  return -1;
};

nativeTrim = String.prototype.trim;

isNumber = function(value) {
  return typeof value === 'number' || toString.call(value) === '[object Number]';
};

isNaN = function(value) {
  return isNumber(value) && (value !== +value);
};

isFinite = function(value) {
  return window.isFinite(value) && !isNaN(parseFloat(value));
};

isArray = function(value) {
  return toString.call(value) === '[object Array]';
};

timeFormats = [
  {
    name: 'second',
    value: 1e3
  }, {
    name: 'minute',
    value: 6e4
  }, {
    name: 'hour',
    value: 36e5
  }, {
    name: 'day',
    value: 864e5
  }, {
    name: 'week',
    value: 6048e5
  }
];

this.Humanize = {};

this.Humanize.intword = function(number, charWidth, decimals) {
  var baseStr, decimalStr, divisor, divisorIndex, divisorList, unitList;
  number = parseInt(number, 10);
  if (number.toString().length <= charWidth) {
    return this.intcomma(number);
  }
  divisorList = [1000, 1000000, 1000000000];
  unitList = ["k", "M", "B"];
  divisorIndex = arrayIndex.call(divisorList, number);
  if (divisorIndex === -1) {
    divisorIndex = sortedIndex(divisorList, number) - 1;
  }
  divisor = divisorList[divisorIndex];
  baseStr = ((number / divisor) + "").slice(0, charWidth);
  decimalStr = baseStr.split('.')[1];
  if (decimals == null) {
    decimals = (decimalStr != null) && parseInt(decimalStr, 10) && decimalStr.length || 0;
  }
  return this.intcomma(baseStr, decimals) + unitList[divisorIndex];
};

this.Humanize.intcomma = function(number, decimals) {
  if (decimals == null) {
    decimals = 0;
  }
  return this.formatNumber(number, decimals);
};

this.Humanize.filesize = function(filesize) {
  var sizeStr;
  if (filesize >= 1073741824) {
    sizeStr = this.formatNumber(filesize / 1073741824, 2, "") + " GB";
  } else if (filesize >= 1048576) {
    sizeStr = this.formatNumber(filesize / 1048576, 2, "") + " MB";
  } else if (filesize >= 1024) {
    sizeStr = this.formatNumber(filesize / 1024, 0) + " KB";
  } else {
    sizeStr = this.formatNumber(filesize, 0) + " bytes";
  }
  return sizeStr;
};

this.Humanize.formatNumber = function(number, precision, thousand, decimal) {
  var base, commas, decimals, firstComma, mod, negative, usePrecision;
  if (precision == null) {
    precision = 0;
  }
  if (thousand == null) {
    thousand = ",";
  }
  if (decimal == null) {
    decimal = ".";
  }
  firstComma = (function(_this) {
    return function(number, thousand, position) {
      if (position) {
        return number.substr(0, position) + thousand;
      } else {
        return "";
      }
    };
  })(this);
  commas = (function(_this) {
    return function(number, thousand, position) {
      return number.substr(position).replace(/(\d{3})(?=\d)/g, "$1" + thousand);
    };
  })(this);
  decimals = (function(_this) {
    return function(number, decimal, usePrecision) {
      if (usePrecision) {
        return decimal + _this.toFixed(Math.abs(number), usePrecision).split(".")[1];
      } else {
        return "";
      }
    };
  })(this);
  usePrecision = this.normalizePrecision(precision);
  negative = number < 0 && "-" || "";
  base = parseInt(this.toFixed(Math.abs(number || 0), usePrecision), 10) + "";
  mod = base.length > 3 ? base.length % 3 : 0;
  return negative + firstComma(base, thousand, mod) + commas(base, thousand, mod) + decimals(number, decimal, usePrecision);
};

this.Humanize.toFixed = function(value, precision) {
  var power;
  if (precision == null) {
    precision = this.normalizePrecision(precision, 0);
  }
  power = Math.pow(10, precision);
  return (Math.round(value * power) / power).toFixed(precision);
};

this.Humanize.normalizePrecision = function(value, base) {
  value = Math.round(Math.abs(value));
  if (isNaN(value)) {
    return base;
  } else {
    return value;
  }
};

this.Humanize.ordinal = function(value) {
  var end, leastSignificant, number, specialCase;
  number = parseInt(value, 10);
  if (number === 0) {
    return value;
  }
  specialCase = number % 100;
  if (specialCase === 11 || specialCase === 12 || specialCase === 13) {
    return number + "th";
  }
  leastSignificant = number % 10;
  switch (leastSignificant) {
    case 1:
      end = "st";
      break;
    case 2:
      end = "nd";
      break;
    case 3:
      end = "rd";
      break;
    default:
      end = "th";
  }
  return number + end;
};

this.Humanize.times = function(value, overrides) {
  var number, result;
  if (overrides == null) {
    overrides = {};
  }
  if (isFinite(value) && value >= 0) {
    number = parseFloat(value);
    switch (number) {
      case 0:
        result = (overrides[0] != null) || 'never';
        break;
      case 1:
        result = (overrides[1] != null) || 'once';
        break;
      case 2:
        result = (overrides[2] != null) || 'twice';
        break;
      default:
        result = (overrides[number] || number) + " times";
    }
  }
  return result;
};

this.Humanize.pluralize = function(number, singular, plural) {
  if (!((number != null) && (singular != null))) {
    return;
  }
  if (plural == null) {
    plural = singular + "s";
  }
  if (parseInt(number, 10) === 1) {
    return singular;
  } else {
    return plural;
  }
};

this.Humanize.truncate = function(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

this.Humanize.truncatewords = function(string, length) {
  var array, i, result;
  array = string.split(" ");
  result = "";
  i = 0;
  while (i < length) {
    if (array[i] != null) {
      result += array[i] + " ";
    }
    i++;
  }
  if (array.length > length) {
    return result += "...";
  }
};

this.Humanize.truncatenumber = function(num, bound, ending) {
  var result;
  if (bound == null) {
    bound = 100;
  }
  if (ending == null) {
    ending = "+";
  }
  result = null;
  if (isFinite(num) && isFinite(bound)) {
    if (num > bound) {
      result = bound + ending;
    }
  }
  return (result || num).toString();
};

this.Humanize.oxford = function(items, limit, limitStr) {
  var extra, limitIndex, numItems;
  numItems = items.length;
  if (numItems < 2) {
    return "" + items;
  } else if (numItems === 2) {
    return items.join(' and ');
  } else if ((limit != null) && numItems > limit) {
    extra = numItems - limit;
    limitIndex = limit;
    if (limitStr == null) {
      limitStr = ", and " + extra + " " + (this.pluralize(extra, 'other'));
    }
  } else {
    limitIndex = -1;
    limitStr = ", and " + items[numItems - 1];
  }
  return items.slice(0, limitIndex).join(', ') + limitStr;
};

this.Humanize.dictionary = function(object, joiner, separator) {
  var defs, k, result, v;
  if (joiner == null) {
    joiner = ' is ';
  }
  if (separator == null) {
    separator = ', ';
  }
  result = '';
  if ((object != null) && typeof object === 'object' && Object.prototype.toString.call(object) !== '[object Array]') {
    defs = [];
    for (k in object) {
      v = object[k];
      defs.push(k + joiner + v);
    }
    result = defs.join(separator);
  }
  return result;
};

this.Humanize.frequency = function(list, verb) {
  var len, str, times;
  if (!isArray(list)) {
    return;
  }
  len = list.length;
  times = this.times(len);
  if (len === 0) {
    str = times + " " + verb;
  } else {
    str = verb + " " + times;
  }
  return str;
};

this.Humanize.pace = function(value, intervalMs, unit) {
  var f, j, len1, prefix, rate, relativePace, roundedPace, timeUnit;
  if (unit == null) {
    unit = 'time';
  }
  if (value === 0 || intervalMs === 0) {
    return "No " + (this.pluralize(unit));
  }
  prefix = 'Approximately';
  timeUnit = null;
  rate = value / intervalMs;
  for (j = 0, len1 = timeFormats.length; j < len1; j++) {
    f = timeFormats[j];
    relativePace = rate * f.value;
    if (relativePace > 1) {
      timeUnit = f.name;
      break;
    }
  }
  if (!timeUnit) {
    prefix = 'Less than';
    relativePace = 1;
    timeUnit = timeFormats[timeFormats.length - 1].name;
  }
  roundedPace = Math.round(relativePace);
  unit = this.pluralize(roundedPace, unit);
  return prefix + " " + roundedPace + " " + unit + " per " + timeUnit;
};

this.Humanize.nl2br = function(string, replacement) {
  if (replacement == null) {
    replacement = '<br/>';
  }
  return string.replace(/\n/g, replacement);
};

this.Humanize.br2nl = function(string, replacement) {
  if (replacement == null) {
    replacement = '\r\n';
  }
  return string.replace(/\<br\s*\/?\>/g, replacement);
};

this.Humanize.capitalize = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

this.Humanize.titlecase = function(string) {
  return string.replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase();
  });
};

this.Humanize.trim = function(string) {
  var whitespace;
  if (!string) {
    return "";
  }
  if (nativeTrim) {
    return nativeTrim.call(string);
  } else {
    whitespace = '\\s';
    return String(string).replace(new RegExp('\^' + whitespace + '+|' + whitespace + '+$', 'g'), '');
  }
};
}());

(function () {
var $, ref, ref1, ref2, storageExists,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

$ = (ref = (ref1 = (ref2 = window.hs) != null ? ref2.jQuery : void 0) != null ? ref1 : window.hsjQuery) != null ? ref : window.jQuery;

if (window.hubspot == null) {
  window.hubspot = {};
}

storageExists = false;

try {
  storageExists = Boolean(window.localStorage && window.localStorage.setItem);
} catch (undefined) {}

window.hubspot.Interframe = (function() {
  function Interframe(remoteDomain, window1, json) {
    this.remoteDomain = remoteDomain;
    this.window = window1;
    this.json = json != null ? json : true;
    this.onMessage = bind(this.onMessage, this);
    this.callbacks = {};
    this.deferreds = {};
    this.queue = [];
    this.idIncrement = 0;
  }

  Interframe.prototype.start = function() {
    window.addEventListener('message', this.onMessage, false);
    return this;
  };

  Interframe.prototype.stop = function() {
    window.removeEventListener('message', this.onMessage, false);
    return this;
  };

  Interframe.prototype.postMessage = function(message, callback) {
    var deferred;
    deferred = $.Deferred();
    if (message.response && message._callbackId) {
      message.response._end = +new Date();
      message.response._start = message._start;
    } else {
      message._start = +new Date();
      this.idIncrement++;
      message._callbackId = this.idIncrement;
      this.deferreds[message._callbackId] = deferred;
      if ($.isFunction(callback)) {
        this.callbacks[message._callbackId] = callback;
      }
    }
    if (this.loading) {
      this.queue.push(message);
    } else {
      this._send(message);
    }
    return deferred.promise();
  };

  Interframe.prototype._send = function(message) {
    var serialized;
    serialized = this.json ? JSON.stringify(message) : message;
    this.log('Posting message to ' + this.remoteDomain);
    this.log(serialized);
    return this.window.postMessage(serialized, this.remoteDomain);
  };

  Interframe.prototype.onMessage = function(e) {
    var error, message, validMessage;
    validMessage = false;
    if (this.json) {
      try {
        message = JSON.parse(e.data);
        if ($.isPlainObject(message)) {
          validMessage = true;
        }
      } catch (error) {
        e = error;
        message = e.data;
      }
    } else {
      validMessage = true;
      message = e.data;
    }
    if (!validMessage) {
      this.log("Invalid message received");
      this.log(e.data);
      return;
    }
    this.log("Received message from " + e.origin);
    this.log(e.data);
    if ($.isPlainObject(message) && message.response && message._callbackId) {
      if (this.callbacks[message._callbackId]) {
        this.callbacks[message._callbackId](message.response);
        delete this.callbacks[message._callbackId];
      }
      if (this.deferreds[message._callbackId]) {
        this.deferreds[message._callbackId].resolve(message.response);
        delete this.deferreds[message._callbackId];
      }
    }
    return $(this).trigger('message', message);
  };

  Interframe.prototype.log = function(message) {
    if (storageExists && (typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('INTERFRAME_DEBUG') : void 0) && (window.console != null) && (window.console.log != null)) {
      return console.log("[Interframe] " + message);
    }
  };

  Interframe.prototype.setLoading = function(loading) {
    var message, results;
    this.loading = loading;
    if (!this.loading) {
      results = [];
      while (message = this.queue.shift()) {
        results.push(this._send(message));
      }
      return results;
    }
  };

  return Interframe;

})();
}());

!function(e){if("object"==typeof exports)module.exports=e();else if("function"==typeof define&&define.amd)define(e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.jade=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = function merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = merge(attrs, a[i]);
    }
    return attrs;
  }
  var ac = a['class'];
  var bc = b['class'];

  if (ac || bc) {
    ac = ac || [];
    bc = bc || [];
    if (!Array.isArray(ac)) ac = [ac];
    if (!Array.isArray(bc)) bc = [bc];
    a['class'] = ac.concat(bc).filter(nulls);
  }

  for (var key in b) {
    if (key != 'class') {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Filter null `val`s.
 *
 * @param {*} val
 * @return {Boolean}
 * @api private
 */

function nulls(val) {
  return val != null && val !== '';
}

/**
 * join array as classes.
 *
 * @param {*} val
 * @return {String}
 */
exports.joinClasses = joinClasses;
function joinClasses(val) {
  return Array.isArray(val) ? val.map(joinClasses).filter(nulls).join(' ') : val;
}

/**
 * Render the given classes.
 *
 * @param {Array} classes
 * @param {Array.<Boolean>} escaped
 * @return {String}
 */
exports.cls = function cls(classes, escaped) {
  var buf = [];
  for (var i = 0; i < classes.length; i++) {
    if (escaped && escaped[i]) {
      buf.push(exports.escape(joinClasses([classes[i]])));
    } else {
      buf.push(joinClasses(classes[i]));
    }
  }
  var text = joinClasses(buf);
  if (text.length) {
    return ' class="' + text + '"';
  } else {
    return '';
  }
};

/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = function attr(key, val, escaped, terse) {
  if ('boolean' == typeof val || null == val) {
    if (val) {
      return ' ' + (terse ? key : key + '="' + key + '"');
    } else {
      return '';
    }
  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
  } else if (escaped) {
    return ' ' + key + '="' + exports.escape(val) + '"';
  } else {
    return ' ' + key + '="' + val + '"';
  }
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} escaped
 * @return {String}
 */
exports.attrs = function attrs(obj, terse){
  var buf = [];

  var keys = Object.keys(obj);

  if (keys.length) {
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i]
        , val = obj[key];

      if ('class' == key) {
        if (val = joinClasses(val)) {
          buf.push(' ' + key + '="' + val + '"');
        }
      } else {
        buf.push(exports.attr(key, val, false, terse));
      }
    }
  }

  return buf.join('');
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

exports.escape = function escape(html){
  var result = String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  if (result === '' + html) return html;
  else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the jade in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @api private
 */

exports.rethrow = function rethrow(err, filename, lineno, str){
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || _dereq_('fs').readFileSync(filename, 'utf8')
  } catch (ex) {
    rethrow(err, null, lineno)
  }
  var context = 3
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Jade') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};

},{"fs":2}],2:[function(_dereq_,module,exports){

},{}]},{},[1])
(1)
});


/**
 * This script gives you the zone info key representing your device's time zone setting.
 *
 * @name jsTimezoneDetect
 * @version 1.0.5
 * @author Jon Nylander
 * @license MIT License - http://www.opensource.org/licenses/mit-license.php
 *
 * For usage and examples, visit:
 * http://pellepim.bitbucket.org/jstz/
 *
 * Copyright (c) Jon Nylander
 */

/*jslint undef: true */
/*global console, exports*/

(function(root) {
  /**
   * Namespace to hold all the code for timezone detection.
   */
  var jstz = (function () {
      'use strict';
      var HEMISPHERE_SOUTH = 's',
          
          /**
           * Gets the offset in minutes from UTC for a certain date.
           * @param {Date} date
           * @returns {Number}
           */
          get_date_offset = function (date) {
              var offset = -date.getTimezoneOffset();
              return (offset !== null ? offset : 0);
          },

          get_date = function (year, month, date) {
              var d = new Date();
              if (year !== undefined) {
                d.setFullYear(year);
              }
              d.setMonth(month);
              d.setDate(date);
              return d;
          },

          get_january_offset = function (year) {
              return get_date_offset(get_date(year, 0 ,2));
          },

          get_june_offset = function (year) {
              return get_date_offset(get_date(year, 5, 2));
          },

          /**
           * Private method.
           * Checks whether a given date is in daylight saving time.
           * If the date supplied is after august, we assume that we're checking
           * for southern hemisphere DST.
           * @param {Date} date
           * @returns {Boolean}
           */
          date_is_dst = function (date) {
              var is_southern = date.getMonth() > 7,
                  base_offset = is_southern ? get_june_offset(date.getFullYear()) : 
                                              get_january_offset(date.getFullYear()),
                  date_offset = get_date_offset(date),
                  is_west = base_offset < 0,
                  dst_offset = base_offset - date_offset;
                  
              if (!is_west && !is_southern) {
                  return dst_offset < 0;
              }

              return dst_offset !== 0;
          },

          /**
           * This function does some basic calculations to create information about
           * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
           * the script has been tested rather than depend on the year set by the
           * client device.
           *
           * Returns a key that can be used to do lookups in jstz.olson.timezones.
           * eg: "720,1,2". 
           *
           * @returns {String}
           */

          lookup_key = function () {
              var january_offset = get_january_offset(),
                  june_offset = get_june_offset(),
                  diff = january_offset - june_offset;

              if (diff < 0) {
                  return january_offset + ",1";
              } else if (diff > 0) {
                  return june_offset + ",1," + HEMISPHERE_SOUTH;
              }

              return january_offset + ",0";
          },

          /**
           * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
           *
           * Returns a primitive object on the format:
           * {'timezone': TimeZone, 'key' : 'the key used to find the TimeZone object'}
           *
           * @returns Object
           */
          determine = function () {
              var key = lookup_key();
              return new jstz.TimeZone(jstz.olson.timezones[key]);
          },

          /**
           * This object contains information on when daylight savings starts for
           * different timezones.
           *
           * The list is short for a reason. Often we do not have to be very specific
           * to single out the correct timezone. But when we do, this list comes in
           * handy.
           *
           * Each value is a date denoting when daylight savings starts for that timezone.
           */
          dst_start_for = function (tz_name) {

            var ru_pre_dst_change = new Date(2010, 6, 15, 1, 0, 0, 0), // In 2010 Russia had DST, this allows us to detect Russia :)
                dst_starts = {
                    'America/Denver': new Date(2011, 2, 13, 3, 0, 0, 0),
                    'America/Mazatlan': new Date(2011, 3, 3, 3, 0, 0, 0),
                    'America/Chicago': new Date(2011, 2, 13, 3, 0, 0, 0),
                    'America/Mexico_City': new Date(2011, 3, 3, 3, 0, 0, 0),
                    'America/Asuncion': new Date(2012, 9, 7, 3, 0, 0, 0),
                    'America/Santiago': new Date(2012, 9, 3, 3, 0, 0, 0),
                    'America/Campo_Grande': new Date(2012, 9, 21, 5, 0, 0, 0),
                    'America/Montevideo': new Date(2011, 9, 2, 3, 0, 0, 0),
                    'America/Sao_Paulo': new Date(2011, 9, 16, 5, 0, 0, 0),
                    'America/Los_Angeles': new Date(2011, 2, 13, 8, 0, 0, 0),
                    'America/Santa_Isabel': new Date(2011, 3, 5, 8, 0, 0, 0),
                    'America/Havana': new Date(2012, 2, 10, 2, 0, 0, 0),
                    'America/New_York': new Date(2012, 2, 10, 7, 0, 0, 0),
                    'Europe/Helsinki': new Date(2013, 2, 31, 5, 0, 0, 0),
                    'Pacific/Auckland': new Date(2011, 8, 26, 7, 0, 0, 0),
                    'America/Halifax': new Date(2011, 2, 13, 6, 0, 0, 0),
                    'America/Goose_Bay': new Date(2011, 2, 13, 2, 1, 0, 0),
                    'America/Miquelon': new Date(2011, 2, 13, 5, 0, 0, 0),
                    'America/Godthab': new Date(2011, 2, 27, 1, 0, 0, 0),
                    'Europe/Moscow': ru_pre_dst_change,
                    'Asia/Amman': new Date(2013, 2, 29, 1, 0, 0, 0),
                    'Asia/Beirut': new Date(2013, 2, 31, 2, 0, 0, 0),
                    'Asia/Damascus': new Date(2013, 3, 6, 2, 0, 0, 0),
                    'Asia/Jerusalem': new Date(2013, 2, 29, 5, 0, 0, 0),
                    'Asia/Yekaterinburg': ru_pre_dst_change,
                    'Asia/Omsk': ru_pre_dst_change,
                    'Asia/Krasnoyarsk': ru_pre_dst_change,
                    'Asia/Irkutsk': ru_pre_dst_change,
                    'Asia/Yakutsk': ru_pre_dst_change,
                    'Asia/Vladivostok': ru_pre_dst_change,
                    'Asia/Baku': new Date(2013, 2, 31, 4, 0, 0),
                    'Asia/Yerevan': new Date(2013, 2, 31, 3, 0, 0),
                    'Asia/Kamchatka': ru_pre_dst_change,
                    'Asia/Gaza': new Date(2010, 2, 27, 4, 0, 0),
                    'Africa/Cairo': new Date(2010, 4, 1, 3, 0, 0),
                    'Europe/Minsk': ru_pre_dst_change,
                    'Pacific/Apia': new Date(2010, 10, 1, 1, 0, 0, 0),
                    'Pacific/Fiji': new Date(2010, 11, 1, 0, 0, 0),
                    'Australia/Perth': new Date(2008, 10, 1, 1, 0, 0, 0)
                };

              return dst_starts[tz_name];
          };

      return {
          determine: determine,
          date_is_dst: date_is_dst,
          dst_start_for: dst_start_for 
      };
  }());

  /**
   * Simple object to perform ambiguity check and to return name of time zone.
   */
  jstz.TimeZone = function (tz_name) {
      'use strict';
        /**
         * The keys in this object are timezones that we know may be ambiguous after
         * a preliminary scan through the olson_tz object.
         *
         * The array of timezones to compare must be in the order that daylight savings
         * starts for the regions.
         */
      var AMBIGUITIES = {
              'America/Denver':       ['America/Denver', 'America/Mazatlan'],
              'America/Chicago':      ['America/Chicago', 'America/Mexico_City'],
              'America/Santiago':     ['America/Santiago', 'America/Asuncion', 'America/Campo_Grande'],
              'America/Montevideo':   ['America/Montevideo', 'America/Sao_Paulo'],
              'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Asia/Beirut', 'Europe/Helsinki','Asia/Damascus'],
              'Pacific/Auckland':     ['Pacific/Auckland', 'Pacific/Fiji'],
              'America/Los_Angeles':  ['America/Los_Angeles', 'America/Santa_Isabel'],
              'America/New_York':     ['America/Havana', 'America/New_York'],
              'America/Halifax':      ['America/Goose_Bay', 'America/Halifax'],
              'America/Godthab':      ['America/Miquelon', 'America/Godthab'],
              'Asia/Dubai':           ['Europe/Moscow'],
              'Asia/Dhaka':           ['Asia/Yekaterinburg'],
              'Asia/Jakarta':         ['Asia/Omsk'],
              'Asia/Shanghai':        ['Asia/Krasnoyarsk', 'Australia/Perth'],
              'Asia/Tokyo':           ['Asia/Irkutsk'],
              'Australia/Brisbane':   ['Asia/Yakutsk'],
              'Pacific/Noumea':       ['Asia/Vladivostok'],
              'Pacific/Tarawa':       ['Asia/Kamchatka', 'Pacific/Fiji'],
              'Pacific/Tongatapu':    ['Pacific/Apia'],
              'Asia/Baghdad':         ['Europe/Minsk'],
              'Asia/Baku':            ['Asia/Yerevan','Asia/Baku'],
              'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
          },

          timezone_name = tz_name,
          
          /**
           * Checks if a timezone has possible ambiguities. I.e timezones that are similar.
           *
           * For example, if the preliminary scan determines that we're in America/Denver.
           * We double check here that we're really there and not in America/Mazatlan.
           *
           * This is done by checking known dates for when daylight savings start for different
           * timezones during 2010 and 2011.
           */
          ambiguity_check = function () {
              var ambiguity_list = AMBIGUITIES[timezone_name],
                  length = ambiguity_list.length,
                  i = 0,
                  tz = ambiguity_list[0];

              for (; i < length; i += 1) {
                  tz = ambiguity_list[i];

                  if (jstz.date_is_dst(jstz.dst_start_for(tz))) {
                      timezone_name = tz;
                      return;
                  }
              }
          },

          /**
           * Checks if it is possible that the timezone is ambiguous.
           */
          is_ambiguous = function () {
              return typeof (AMBIGUITIES[timezone_name]) !== 'undefined';
          };

      if (is_ambiguous()) {
          ambiguity_check();
      }

      return {
          name: function () {
              return timezone_name;
          }
      };
  };

  jstz.olson = {};

  /*
   * The keys in this dictionary are comma separated as such:
   *
   * First the offset compared to UTC time in minutes.
   *
   * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
   * does.
   *
   * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
   * only interesting for timezones with DST.
   *
   * The mapped arrays is used for constructing the jstz.TimeZone object from within
   * jstz.determine_timezone();
   */
  jstz.olson.timezones = {
      '-720,0'   : 'Pacific/Majuro',
      '-660,0'   : 'Pacific/Pago_Pago',
      '-600,1'   : 'America/Adak',
      '-600,0'   : 'Pacific/Honolulu',
      '-570,0'   : 'Pacific/Marquesas',
      '-540,0'   : 'Pacific/Gambier',
      '-540,1'   : 'America/Anchorage',
      '-480,1'   : 'America/Los_Angeles',
      '-480,0'   : 'Pacific/Pitcairn',
      '-420,0'   : 'America/Phoenix',
      '-420,1'   : 'America/Denver',
      '-360,0'   : 'America/Guatemala',
      '-360,1'   : 'America/Chicago',
      '-360,1,s' : 'Pacific/Easter',
      '-300,0'   : 'America/Bogota',
      '-300,1'   : 'America/New_York',
      '-270,0'   : 'America/Caracas',
      '-240,1'   : 'America/Halifax',
      '-240,0'   : 'America/Santo_Domingo',
      '-240,1,s' : 'America/Santiago',
      '-210,1'   : 'America/St_Johns',
      '-180,1'   : 'America/Godthab',
      '-180,0'   : 'America/Argentina/Buenos_Aires',
      '-180,1,s' : 'America/Montevideo',
      '-120,0'   : 'America/Noronha',
      '-120,1'   : 'America/Noronha',
      '-60,1'    : 'Atlantic/Azores',
      '-60,0'    : 'Atlantic/Cape_Verde',
      '0,0'      : 'UTC',
      '0,1'      : 'Europe/London',
      '60,1'     : 'Europe/Berlin',
      '60,0'     : 'Africa/Lagos',
      '60,1,s'   : 'Africa/Windhoek',
      '120,1'    : 'Asia/Beirut',
      '120,0'    : 'Africa/Johannesburg',
      '180,0'    : 'Asia/Baghdad',
      '180,1'    : 'Europe/Moscow',
      '210,1'    : 'Asia/Tehran',
      '240,0'    : 'Asia/Dubai',
      '240,1'    : 'Asia/Baku',
      '270,0'    : 'Asia/Kabul',
      '300,1'    : 'Asia/Yekaterinburg',
      '300,0'    : 'Asia/Karachi',
      '330,0'    : 'Asia/Kolkata',
      '345,0'    : 'Asia/Kathmandu',
      '360,0'    : 'Asia/Dhaka',
      '360,1'    : 'Asia/Omsk',
      '390,0'    : 'Asia/Rangoon',
      '420,1'    : 'Asia/Krasnoyarsk',
      '420,0'    : 'Asia/Jakarta',
      '480,0'    : 'Asia/Shanghai',
      '480,1'    : 'Asia/Irkutsk',
      '525,0'    : 'Australia/Eucla',
      '525,1,s'  : 'Australia/Eucla',
      '540,1'    : 'Asia/Yakutsk',
      '540,0'    : 'Asia/Tokyo',
      '570,0'    : 'Australia/Darwin',
      '570,1,s'  : 'Australia/Adelaide',
      '600,0'    : 'Australia/Brisbane',
      '600,1'    : 'Asia/Vladivostok',
      '600,1,s'  : 'Australia/Sydney',
      '630,1,s'  : 'Australia/Lord_Howe',
      '660,1'    : 'Asia/Kamchatka',
      '660,0'    : 'Pacific/Noumea',
      '690,0'    : 'Pacific/Norfolk',
      '720,1,s'  : 'Pacific/Auckland',
      '720,0'    : 'Pacific/Tarawa',
      '765,1,s'  : 'Pacific/Chatham',
      '780,0'    : 'Pacific/Tongatapu',
      '780,1,s'  : 'Pacific/Apia',
      '840,0'    : 'Pacific/Kiritimati'
  };

  if (typeof exports !== 'undefined') {
    exports.jstz = jstz;
  } else {
    root.jstz = jstz;
  }
})(this);



(function() {
  var Mixen, indexOf, moduleSuper, uniqueId,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  indexOf = function(haystack, needle) {
    var i, stalk, _i, _len;
    for (i = _i = 0, _len = haystack.length; _i < _len; i = ++_i) {
      stalk = haystack[i];
      if (stalk === needle) {
        return i;
      }
    }
    return -1;
  };

  uniqueId = (function() {
    var id;
    id = 0;
    return function() {
      return id++;
    };
  })();

  Mixen = function() {
    return Mixen.createMixen.apply(Mixen, arguments);
  };

  Mixen.createdMixens = {};

  Mixen.createMixen = function() {
    var Inst, Last, method, mods, module, _base, _i, _len, _ref, _ref1;
    mods = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
    Last = mods[mods.length - 1];
    _ref = mods.slice(0).reverse();
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      module = _ref[_i];
      Inst = (function(_super) {
        __extends(Inst, _super);

        function Inst() {
          var args, mod, _j, _len1;
          args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
          for (_j = 0, _len1 = mods.length; _j < _len1; _j++) {
            mod = mods[_j];
            mod.apply(this, args);
          }
        }

        return Inst;

      })(Last);
      Last = Inst;
      for (method in module.prototype) {
        Inst.prototype[method] = module.prototype[method];
      }
      _ref1 = module.prototype;
      for (method in _ref1) {
        if (!__hasProp.call(_ref1, method)) continue;
        if (method === 'constructor') {
          continue;
        }
        if (typeof module.prototype[method] !== 'function') {
          continue;
        }
        if (module.__super__ == null) {
          module.__super__ = {};
        }
        if ((_base = module.__super__)[method] == null) {
          _base[method] = moduleSuper(module, method);
        }
      }
    }
    Last.prototype._mixen_id = uniqueId();
    Mixen.createdMixens[Last.prototype._mixen_id] = mods;
    return Last;
  };

  moduleSuper = function(module, method) {
    return function() {
      var args, current, id, modules, nextModule, pos;
      args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      current = this.constructor.prototype;
      id = null;
      while (true) {
        if (current === Object.prototype) {
          return;
        }
        id = current._mixen_id;
        if (id != null) {
          break;
        }
        current = current.constructor.__super__.constructor.prototype;
      }
      if (id == null) {
        return;
      }
      modules = Mixen.createdMixens[id];
      pos = indexOf(modules, module);
      nextModule = null;
      while (pos++ < modules.length - 1) {
        nextModule = modules[pos];
        if (nextModule.prototype[method] != null) {
          break;
        }
      }
      if ((nextModule != null) && (nextModule.prototype != null) && (nextModule.prototype[method] != null)) {
        return nextModule.prototype[method].apply(this, args);
      }
    };
  };

  if (typeof define === 'function' && define.amd) {
    define(function() {
      return Mixen;
    });
  } else if (typeof exports === 'object') {
    module.exports = Mixen;
  } else {
    window.Mixen = Mixen;
  }

}).call(this);



(function() {
  var module = {};
  var result = {};
  module.exports = { "cs": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Podpis", "preview": "Náhled", "editEmailSignature": "Upravit e-mailový podpis", "save": "Uložit", "visual": "Jednoduchý", "text": "HTML", "cancel": "Zrušit", "update": { "prompt": "Provést tyto změny také v podpisu pro můj účet", "tooltip": "Chcete-li upravit pouze podpis v e-mailu, který právě píšete, toto políčko nezaškrtávejte." }, "signatureSaved": "Podpis byl uložen." }, "descriptions": { "signature": "Podpis se bude používat v e-mailech určených jednotlivcům a odesílaným prostřednictvím aplikace HubSpot CRM." }, "errors": { "title": "Něco se pokazilo.", "unableToLoadSignature": "Při nahrávání e-mailového podpisu došlo k chybě. Zkuste to znovu.", "unableToUpdateSignature": "Při ukládání e-mailového podpisu došlo k chybě. Zkuste to znovu.", "signatureTooLong": "E-mailový podpis je příliš dlouhý, a proto jej není možné uložit. Podpis nesmí mít více než {{ maxLength }} znaků. Zkuste jej zkrátit." }, "unsupportedHTML": { "header": "Přepnutí režimů se nezdařilo.", "description": "Podpis obsahuje prvky HTML, které editor jednoduchého textu nepodporuje. Použijte prosím tlačítko HTML a upravte podpis v editoru nezpracovaného kódu HTML.", "saveButtonDisabled": "Váš podpis obsahuje nepodporované prvky HTML. Odeberte z něj prosím některé z následujících štítků:" }, "unsubscribeLink": { "link": "sem", "RELEVANT": "Připadá vám tento e-mail nezajímavý? Klikněte {{ link }}", "STOP_GETTING_MESSAGES": "Pokud již tyto e-maily nechcete dostávat, klikněte {{ link }}", "PREFER_LESS": "Chcete ode mne dostávat méně e-mailů? Klikněte {{ link }}", "edit": { "header": "Vyberte odkaz pro odhlášení odběru", "submit": "Použít", "cancel": "Zrušit", "removeLink": "Odstranit odkaz" }, "info": { "header": "K čemu tu je toto?", "list": { "one": "Aplikace HubSpot respektuje odesílatele i příjemce, a proto oběma stranám umožňuje, aby rozhodovaly o komunikaci.", "two": "Z právního hlediska to je nezbytné. {{ infoLink }} a přečtěte si podrobnosti." }, "infoLink": "Klikněte sem" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:cs', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "signatureEditorModal": { "labels": { "ok": "Okay", "signature": "Underskrift", "preview": "Forhåndsvisning", "editEmailSignature": "E-mailsignatur", "save": "Gem", "visual": "Simpel", "text": "HTML", "cancel": "Annuller", "update": { "prompt": "Opdater også min kontosignatur med disse ændringer", "tooltip": "Du skal ikke markere denne boks, hvis du kun vil have opdateret e-mailsignaturen i den e-mail, du er i gang med at skrive." }, "signatureSaved": "Din signatur er gemt." }, "descriptions": { "signature": "Din signatur vil blive brugt i en-til-en e-mails i hele HubSport CRM." }, "errors": { "title": "Noget gik galt", "unableToLoadSignature": "Der opstod en fejl under indlæsning af din e-mailsignatur. Prøv igen.", "unableToUpdateSignature": "Der opstod en fejl under gemning af din e-mailsignatur. Prøv igen.", "signatureTooLong": "Din e-mail-signatur er for lang og kan ikke gemmes. Den skal være på mindre end {{ maxLength }} tegn. Prøv at gøre den mindre." }, "unsupportedHTML": { "header": "Kunne ikke ændre tilstand", "description": "Din e-mailsignatur indeholder nogle HTML-elementer, der ikke understøttes i den simple editor. Brug HTML-knappen for at redigere din signatur med den rå HTML-editor.", "saveButtonDisabled": "Din underskrift har ikke-understøttet HTML. Fjern følgende tags fra din underskrift:" }, "unsubscribeLink": { "link": "her", "RELEVANT": "Er denne mail ikke relevant for dig? Klik på {{ link }}", "STOP_GETTING_MESSAGES": "For at stoppe med at modtage disse mails, klik på {{ link }}", "PREFER_LESS": "Foretrækker du færre e-mails fra mig? Klik på {{ link }}", "edit": { "header": "Vælg et link til afmelding", "submit": "Anvend", "cancel": "Annuller", "removeLink": "Fjern link" }, "info": { "header": "Hvor ser jeg dette?", "list": { "one": "HubSpot respekterer både afsender og modtager ved at lade begge styre kommunikationen.", "two": "Dette er juridisk nødvendigt. {{ infoLink }}for at få mere at vide." }, "infoLink": "Klik her" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "da": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:da', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "de": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Signatur", "preview": "Vorschau", "editEmailSignature": "Signatur bearbeiten", "save": "Speichern", "visual": "Einfach", "text": "HTML", "cancel": "Abbrechen", "update": { "prompt": "Diese Änderungen auch in der Account-Signatur vornehmen", "tooltip": "Lassen Sie dieses Kontrollkästchen deaktiviert, um lediglich die Signatur in der E-Mail zu aktualisieren, an der Sie arbeiten" }, "signatureSaved": "Ihre Signatur wurde gespeichert." }, "descriptions": { "signature": "Ihre Signatur wird in sämtlichen persönlichen E-Mails verwendet, die Sie im HubSpot CRM erstellen." }, "errors": { "title": "Es ist ein Fehler aufgetreten", "unableToLoadSignature": "Beim Laden Ihrer E-Mail-Signatur ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", "unableToUpdateSignature": "Beim Speichern Ihrer E-Mail-Signatur ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", "signatureTooLong": "Ihre E-Mail-Signatur ist zu lang und kann nicht gespeichert werden. Sie muss weniger als {{ maxLength }} Zeichen lang sein. Versuchen Sie, sie zu kürzen." }, "unsupportedHTML": { "header": "Modus kann nicht gewechselt werden", "description": "Ihre Signatur enthält HTML-Elemente, die im einfachen Editor nicht unterstützt werden. Bitte nutzen Sie die HTML-Schaltfläche, um Ihre Signatur im HTML-Editor zu bearbeiten.", "saveButtonDisabled": "Ihre Signatur enthält nicht unterstützten HTML-Code. Bitte entfernen Sie eines der folgenden Tags aus Ihrer Signatur:" }, "unsubscribeLink": { "link": "hier", "RELEVANT": "Ist diese E-Mail nicht relevant? Bitte {{ link }} klicken.", "STOP_GETTING_MESSAGES": "Um diese E-Mails abzubestellen, bitte {{ link }} klicken.", "PREFER_LESS": " Schicken wir zu viele E-Mails? Bitte {{ link }} klicken.", "edit": { "header": "Abmelde-Link wählen", "submit": "Auswählen", "cancel": "Abbrechen", "removeLink": "Link entfernen" }, "info": { "header": "Warum gibt es diesen Link?", "list": { "one": "HubSpot erlaubt sowohl dem Absender als auch dem Empfänger, den Kommunikationsfluss zu verwalten.", "two": "Dies ist gesetzlich vorgeschrieben. {{ infoLink }}, um mehr zu erfahren." }, "infoLink": "Klicken Sie hier" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "de": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:de', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "el": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Υπογραφή", "preview": "Προεπισκόπηση", "editEmailSignature": "Επεξεργασία υπογραφής email", "save": "Αποθήκευση", "visual": "Απλό", "text": "HTML", "cancel": "Άκυρο", "update": { "prompt": "Να ενημερωθεί επίσης η υπογραφή του λογαριασμού μου με αυτές τις αλλαγές", "tooltip": "Αφήστε αυτό το πλαίσιο μη επιλεγμένο για να ενημερώσετε μόνο την υπογραφή στο email που συντάσσετε αυτήν τη στιγμή" }, "signatureSaved": "Η υπογραφή σας έχει αποθηκευτεί." }, "descriptions": { "signature": "Η υπογραφή σας θα χρησιμοποιείται σε προσωπικά μηνύματα σε όλο το CRM της HubSpot." }, "errors": { "title": "Κάτι πήγε στραβά", "unableToLoadSignature": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια φόρτωσης της υπογραφής σας για email. Δοκιμάστε ξανά. ", "unableToUpdateSignature": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια αποθήκευσης της υπογραφής σας για email. Δοκιμάστε ξανά. ", "signatureTooLong": "Η υπογραφή σας για email είναι πολύ μεγάλη και δεν είναι δυνατή η αποθήκευσή της. Πρέπει να είναι μικρότερη από {{ maxLength }} χαρακτήρες. Δοκιμάστε να τη μικρύνετε." }, "unsupportedHTML": { "header": "Δεν είναι δυνατή η εναλλαγή λειτουργιών", "description": "Η υπογραφή σας έχει κάποια στοιχεία HTML που δεν υποστηρίζονται στον απλό επεξεργαστή. Χρησιμοποιήστε το κουμπί HTML για να επεξεργαστείτε την υπογραφή σας με τον επεξεργαστή HTML.", "saveButtonDisabled": "Η υπογραφή σας περιλαμβάνει μη υποστηριζόμενη HTML. Αφαιρέστε από την υπογραφή σας οποιεσδήποτε από τις παρακάτω ετικέτες:" }, "unsubscribeLink": { "link": "εδώ", "RELEVANT": "Αυτό το email δεν σας αφορά; Κάντε κλικ στο {{ link }}", "STOP_GETTING_MESSAGES": "Για να σταματήσετε να λαμβάνετε αυτά τα email, κάντε κλικ στο {{ link }}", "PREFER_LESS": "Θα προτιμούσατε να λαμβάνετε λιγότερα email από εμένα; Κάντε κλικ στο {{ link }}", "edit": { "header": "Επιλέξτε έναν σύνδεσμο διαγραφής από τους συνδρομητές", "submit": "Εφαρμογή", "cancel": "Άκυρο", "removeLink": "Αφαίρεση συνδέσμου" }, "info": { "header": "Γιατί βρίσκεται αυτό εδώ;", "list": { "one": "Η HubSpot σέβεται τον αποστολέα και τον παραλήπτη επιτρέποντας και στις δύο πλευρές να διαχειρίζονται τις συνομιλίες.", "two": "Αυτό είναι νομικά απαραίτητο. Κάντε κλικ στο{{ infoLink }} για να διαβάσετε περισσότερα." }, "infoLink": "Κάντε κλικ εδώ" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "el": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:el', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "signatureEditorModal": { "labels": { "ok": "Okay", "signature": "Signature", "preview": "Preview", "editEmailSignature": "Edit email signature", "save": "Save", "visual": "Simple", "text": "HTML", "cancel": "Cancel", "update": { "prompt": "Also update my account signature with these changes", "tooltip": "Leave this box unchecked to only update the signature in the email you are composing" }, "signatureSaved": "Your signature has been saved." }, "descriptions": { "signature": "Your signature will be used in one-on-one emails throughout the HubSpot CRM." }, "errors": { "title": "Something went wrong", "unableToLoadSignature": "An error occurred while trying to load your email signature. Please try again.", "unableToUpdateSignature": "An error occurred while trying to save your email signature. Please try again.", "signatureTooLong": "Your email signature is too long and can't be saved. It must be less than {{ maxLength }} characters. Try making it smaller." }, "unsupportedHTML": { "header": "Unable to switch modes", "description": "Your signature has some HTML elements that aren't supported in the simple editor. Please use the HTML button to edit your signature with the raw HTML editor.", "saveButtonDisabled": "Your signature has unsupported HTML. Please remove any of the following tags from your signature:" }, "unsubscribeLink": { "link": "here", "RELEVANT": "Is this email not relevant to you? Click {{ link }}", "STOP_GETTING_MESSAGES": "To stop receiving these emails, click {{ link }}", "PREFER_LESS": "Prefer fewer emails from me? Click {{ link }}", "edit": { "header": "Choose an unsubscribe link", "submit": "Apply", "cancel": "Cancel", "removeLink": "Remove link" }, "info": { "header": "Why is this here?", "list": { "one": "HubSpot respects the sender and the recipient by allowing both sides to manage communications.", "two": "This is legally necessary. {{ infoLink }} to read more." }, "infoLink": "Click here" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "en": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:en', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es-mx": { "signatureEditorModal": { "labels": { "ok": "De acuerdo", "signature": "Firma", "preview": "Vista preliminar", "editEmailSignature": "Editar firma de correo", "save": "Guardar", "visual": "Simple", "text": "HTML", "cancel": "Cancelar", "update": { "prompt": "Actualizar además la firma de mi cuenta con estos cambios", "tooltip": "Deja esta casilla sin marcar para actualizar solo la firma en el correo electrónico que estás redactando" }, "signatureSaved": "Se guardó tu firma." }, "descriptions": { "signature": "Se usará tu firma en correos personalizados en todo HubSpot CRM." }, "errors": { "title": "Algo salió mal", "unableToLoadSignature": "Se produjo un error al intentar cargar tu firma de correo electrónico. Intenta de nuevo.", "unableToUpdateSignature": "Se produjo un error al intentar guardar tu firma de correo electrónico. Intenta de nuevo.", "signatureTooLong": "Tu firma de correo electrónico es demasiado larga y no se puede guardar. Debe tener menos de {{ maxLength }} caracteres. Intenta hacerla más pequeño." }, "unsupportedHTML": { "header": "No es posible cambiar de modo", "description": "Tu firma tiene algunos elementos HTML que no son compatibles con el editor simple. Utiliza el botón HTML para editar tu firma con el editor de HTML sin procesar.", "saveButtonDisabled": "Tu firma tiene HTML no admitido. Por favor, elimina cualquiera de las siguientes etiquetas de tu firma:" }, "unsubscribeLink": { "link": "aquí", "RELEVANT": "¿Este correo no es relevante para ti? Haz clic {{ link }}", "STOP_GETTING_MESSAGES": "Para dejar de recibir estos correos, haz clic {{ link }}", "PREFER_LESS": "¿Prefieres recibir menos correos de mi parte? Haz clic {{ link }}", "edit": { "header": "Elige un enlace para cancelar tu suscripción", "submit": "Aplicar", "cancel": "Cancelar", "removeLink": "Eliminar enlace" }, "info": { "header": "¿Por qué está esto aquí?", "list": { "one": "HubSpot respeta al remitente y al destinatario al permitir que ambas partes administren las comunicaciones.", "two": "Esto es necesario en términos legales. {{ infoLink }} para leer más." }, "infoLink": "Haz clic aquí" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "es-mx": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:es-mx', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Firma", "preview": "Previsualizar", "editEmailSignature": "Editar firma de correo electrónico", "save": "Guardar", "visual": "Simple", "text": "HTML", "cancel": "Cancelar", "update": { "prompt": "Actualizar también la firma de mi cuenta con estos cambios", "tooltip": "Deje esta casilla sin marcar para actualizar solo la firma en el correo electrónico que está redactando" }, "signatureSaved": "Su firma ha sido guardada" }, "descriptions": { "signature": "Su firma se usará en mensajes de correo electrónico personalizados enviados a través de HubSpot CRM." }, "errors": { "title": "Algo salió mal", "unableToLoadSignature": "Se produjo un error al intentar cargar su firma de correo electrónico. Inténtelo de nuevo.", "unableToUpdateSignature": "Se produjo un error al intentar guardar su firma de correo electrónico. Inténtelo de nuevo.", "signatureTooLong": "Su firma de correo electrónico es demasiado larga y no se puede guardar. Debe tener menos de {{ maxLength }} caracteres. Intente hacerla más pequeña." }, "unsupportedHTML": { "header": "No se pueden cambiar los modos", "description": "Su firma tiene algunos elementos HTML que no son compatibles con el editor simple. Utilice el botón HTML para editar su firma con el editor de HTML sin procesar.", "saveButtonDisabled": "Su firma tiene HTML no admitido. Elimine cualquiera de las siguientes etiquetas de su firma:" }, "unsubscribeLink": { "link": "aquí", "RELEVANT": "¿Este correo electrónico no es relevante para usted? Haga clic {{ link }}", "STOP_GETTING_MESSAGES": "Para dejar de recibir estos correos electrónicos, haga clic {{ link }}", "PREFER_LESS": "¿Prefiere menos correos electrónicos de mi parte? Haga clic {{ link }}", "edit": { "header": "Elija un enlace para darse de baja", "submit": "Aplicar", "cancel": "Cancelar", "removeLink": "Eliminar enlace" }, "info": { "header": "¿Por qué está esto aquí?", "list": { "one": "HubSpot respeta al remitente y al destinatario al permitir que ambas partes administren las comunicaciones.", "two": "Esto es legalmente necesario. {{ infoLink }} para leer más." }, "infoLink": "Haga clic aquí" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "es": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:es', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fi": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Allekirjoitus", "preview": "Esikatselu", "editEmailSignature": "Muokkaa sähköpostin allekirjoitusta", "save": "Tallenna", "visual": "Yksinkertainen", "text": "HTML", "cancel": "Peruuta", "update": { "prompt": "Tallenna nämä muutokset myös sähköpostini allekirjoitukseen.", "tooltip": "Jos haluat muokata vain nyt kirjoittamasi sähköpostin allekirjoitusta, älä valitse tätä valintaruutua." }, "signatureSaved": "Allekirjoituksesi on tallennettu." }, "descriptions": { "signature": "Allekirjoitustasi käytetään yhdelle henkilölle lähetettävissä viesteissä HubSpot CRM:ssä." }, "errors": { "title": "Jokin meni pieleen", "unableToLoadSignature": "Sähköpostin allekirjoitusta ladatessa tapahtui virhe. Yritä uudelleen.", "unableToUpdateSignature": "Sähköpostin allekirjoitusta tallennettaessa tapahtui virhe. Yritä uudelleen.", "signatureTooLong": "Sähköpostin allekirjoituksesi on liian pitkä, eikä sitä voi tallentaa. Se voi olla enintään {{ maxLength }} merkkiä. Koita lyhentää allekirjoitusta." }, "unsupportedHTML": { "header": "Tilaa ei voi vaihtaa", "description": "Allekirjoituksessasi on HTML-elementtejä, joita yksinkertaisen tekstin muokkausohjelma ei tue. Muokkaa allekirjoitustasi ottamalla pelkistetyn HTML:n muokkausohjelma käyttään painamalla HTML-painiketta.", "saveButtonDisabled": "Allekirjoituksessasi on HTML-koodia, jota ei tueta. Poista seuraavat tunnisteet allekirjoituksestasi:" }, "unsubscribeLink": { "link": "tässä", "RELEVANT": "Onko tämä sähköposti sinulle epäolennainen? Valitse {{ link }}", "STOP_GETTING_MESSAGES": "Jos et halua enää vastaanottaa näitä sähköposteja, valitse {{ link }}", "PREFER_LESS": "Haluaisitko vastaanottaa minulta vähemmän viestejä? Valitse {{ link }}", "edit": { "header": "Valitse tilauksen lopetuslinkki", "submit": "Käytä", "cancel": "Peruuta", "removeLink": "Poista linkki" }, "info": { "header": "Miksi tämä on tässä?", "list": { "one": "HubSpot kunnioittaa lähettäjää ja vastaanottajaa antamalla kummankin hallita viestintää.", "two": "Tämä on lain vaatimus. Lisätietoja: {{ infoLink }} " }, "infoLink": "Napsauta tätä" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "fi": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:fi', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr": { "signatureEditorModal": { "labels": { "ok": "Ok", "signature": "Signature", "preview": "Aperçu", "editEmailSignature": "Modifier la signature de l'e-mail", "save": "Sauvegarder", "visual": "Simple", "text": "HTML", "cancel": "Annuler", "update": { "prompt": "Mettre également à jour ma signature de compte avec ces modifications", "tooltip": "Ne cochez pas cette case pour mettre à jour uniquement la signature dans l'e-mail que vous rédigez" }, "signatureSaved": "Votre signature a été enregistrée." }, "descriptions": { "signature": "Votre signature sera utilisée dans les e-mails individuels dans HubSpot CRM." }, "errors": { "title": "Une erreur s'est produite", "unableToLoadSignature": "Une erreur est survenue lors de la tentative de chargement de votre signature électronique. Veuillez réessayer.", "unableToUpdateSignature": "Une erreur est survenue lors de la tentative d'enregistrement de votre signature électronique. Veuillez réessayer.", "signatureTooLong": "Votre signature électronique est trop longue et ne peut pas être enregistrée. Elle doit contenir moins de {{ maxLength }} caractères. Essayez de le rendre plus petit." }, "unsupportedHTML": { "header": "Impossible de changer de mode", "description": "Votre signature comporte des éléments HTML qui ne sont pas pris en charge dans l'éditeur simple. Veuillez utiliser le bouton HTML pour modifier votre signature avec l'éditeur HTML brut.", "saveButtonDisabled": "Votre signature contient du code HTML non pris en charge. Veuillez supprimer l'une des balises suivantes de votre signature :" }, "unsubscribeLink": { "link": "ici", "RELEVANT": "Cet e-mail ne vous concerne pas ? Cliquez {{ link }}", "STOP_GETTING_MESSAGES": "Pour ne plus recevoir ces e-mails, cliquez {{ link }}", "PREFER_LESS": "Vous préférez recevoir moins d'e-mails de ma part ? Cliquez {{ link }}", "edit": { "header": "Choisissez un lien de désabonnement", "submit": "Appliquer", "cancel": "Annuler", "removeLink": "Supprimer le lien" }, "info": { "header": "Pourquoi je vois cela ?", "list": { "one": "HubSpot respecte l'expéditeur et le destinataire en permettant aux deux parties de gérer les communications.", "two": "Ceci est juridiquement nécessaire. {{ infoLink }} pour en savoir plus." }, "infoLink": "Cliquez ici" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "fr": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:fr', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "it": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Firma", "preview": "Anteprima", "editEmailSignature": "Modifica firma e-mail", "save": "Salva", "visual": "Semplice", "text": "HTML", "cancel": "Annulla", "update": { "prompt": "Aggiorna anche la firma del mio account con queste modifiche", "tooltip": "Non aggiungere il segno di spunta a questa casella per aggiornare solo la firma dell'e-mail che stai scrivendo" }, "signatureSaved": "La firma è stata salvata" }, "descriptions": { "signature": "La firma sarà utilizzata negli scambi di e-mail diretti in HubSport CRM" }, "errors": { "title": "C'è stato un imprevisto", "unableToLoadSignature": "Si è verificato un errore durante il caricamento della firma e-mail. Riprova.", "unableToUpdateSignature": "Si è verificato un errore durante il salvataggio della firma e-mail. Riprova.", "signatureTooLong": "La firma e-mail è troppo lunga e non è possibile salvarla. Deve essere inferiore a {{ maxLength }} caratteri. Prova ad accorciarla" }, "unsupportedHTML": { "header": "Impossibile cambiare modalità", "description": "La firma contiene elementi HTML non supportati dall'editor semplice, Utilizza il pulsante HTML per modificare la firma con l'editor HTML.", "saveButtonDisabled": "La firma contiene codice HTML non supportato. Rimuovi i seguenti tag qualora siano contenuti nella tua firma:" }, "unsubscribeLink": { "link": "qui", "RELEVANT": "Questa mail è rilevante per te? Fai clic su{{ link }}", "STOP_GETTING_MESSAGES": "Per non ricevere più queste e-mail, fai clic su {{ link }}", "PREFER_LESS": "Vorresti ricevere meno e-mail da me? Clicca {{ link }}", "edit": { "header": "Scegli un collegamento di annullamento dell'iscrizione ", "submit": "Applica", "cancel": "Annulla", "removeLink": "Elimina collegamento" }, "info": { "header": "Perché questo è qui?", "list": { "one": "Hubspot dimostra il proprio rispetto per mittente e destinatario consentendo a entrambi di gestire le comunicazioni.", "two": "È previsto per legge. {{ infoLink }} per saperne di più." }, "infoLink": "Fai clic qui" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "it": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:it', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "署名", "preview": "プレビュー", "editEmailSignature": "Eメール署名を編集", "save": "保存", "visual": "シンプル", "text": "HTML", "cancel": "キャンセル", "update": { "prompt": "この変更と共にアカウント署名も更新", "tooltip": "作成しているEメールの署名のみを更新する場合は、このボックスはオフのままにしておきます。" }, "signatureSaved": "署名が保存されました。" }, "descriptions": { "signature": "HubSpot CRM全体を通じて、署名は1対1のEメールで使用されます。" }, "errors": { "title": "何か問題が起きたようです", "unableToLoadSignature": "Eメール署名の読み込み中にエラーが発生しました。もう一度お試しください。", "unableToUpdateSignature": "Eメール署名の保存中にエラーが発生しました。もう一度お試しください。", "signatureTooLong": "Eメール署名が長すぎて保存できません。{{ maxLength }}文字以下にする必要があります。署名を短くしてください。" }, "unsupportedHTML": { "header": "モードの切り替えができません", "description": "シンプルエディタではサポートされていないHTML要素が署名に含まれています。HTMLボタンを使用してローHTMLエディタで署名を編集してください。", "saveButtonDisabled": "署名にサポートされないHTMLが含まれています。署名から次のタグをすべて削除してください：" }, "unsubscribeLink": { "link": "こちら", "RELEVANT": "このEメールが無関係な場合は、{{ link }}をクリックしてください。", "STOP_GETTING_MESSAGES": "これらのEメールの受信を止めるには、{{ link }}をクリックしてください。", "PREFER_LESS": "私からのEメールの送信数を減らしたい場合は、{{ link }}をクリックしてください。", "edit": { "header": "配信解除リンクを選択", "submit": "適用", "cancel": "キャンセル", "removeLink": "リンクを削除" }, "info": { "header": "これが表示される理由", "list": { "one": "HubSpotでは、送信者と受信者の双方でコミュニケーションを管理できるようになっています。", "two": "これは法的な義務です。詳細については{{ infoLink }}をご参照ください。" }, "infoLink": "ここをクリック" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "ja": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:ja', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "signatureEditorModal": { "labels": { "ok": "확인", "signature": "서명", "preview": "미리 보기", "editEmailSignature": "이메일 서명 편집", "save": "저장", "visual": "간단히", "text": "HTML", "cancel": "취소", "update": { "prompt": "이 변경 사항으로 내 계정 서명 업데이트", "tooltip": "작성 중인 이메일에서 서명을 업데이트하려면 이 상자를 선택하지 마십시오." }, "signatureSaved": "서명이 저장되었습니다." }, "descriptions": { "signature": "귀하의 서명은 HubSpot CRM에서 일대일 이메일에 사용됩니다." }, "errors": { "title": "문제가 발생했습니다.", "unableToLoadSignature": "이메일 서명을 로드하는 동안 오류가 발생했습니다. 다시 시도하십시오.", "unableToUpdateSignature": "이메일 서명을 저장하는 동안 오류가 발생했습니다. 다시 시도하십시오.", "signatureTooLong": "이메일 서명이 너무 길어 저장할 수 없습니다. 서명은 {{ maxLength }}자 이하여야 합니다. 더 짧게 만드십시오." }, "unsupportedHTML": { "header": "모드를 전환할 수 없음", "description": "간단한 편집기에서 지원되지 않는 HTML 요소가 서명에 있습니다. HTML 버튼을 사용하여 원시 HTML 편집기에서 서명을 편집하십시오.", "saveButtonDisabled": "서명에 지원되지 않는 HTML이 포함되어 있습니다. 서명에서 다음 태그 중 하나를 제거하십시오." }, "unsubscribeLink": { "link": "여기", "RELEVANT": "이 이메일은 귀하와 관련이 없나요? {{ link }}을(를) 클릭하세요.", "STOP_GETTING_MESSAGES": "이 이메일을 받지 않으려면 {{ link }}을(를) 클릭하세요.", "PREFER_LESS": "제가 보내는 이메일 수를 줄이고 싶으세요? {{ link }} 클릭", "edit": { "header": "구독 취소 링크 선택", "submit": "적용", "cancel": "취소", "removeLink": "링크 제거" }, "info": { "header": "이것이 왜 여기에 있나요?", "list": { "one": "HubSpot은 발신자와 수신자가 모두 연락 내용을 관리할 수 있도록 합니다.", "two": "이것은 법적으로 필요합니다. 자세히 보려면 {{ infoLink }}을(를) 클릭하세요." }, "infoLink": "여기를 클릭하세요" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "ko": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:ko', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "nl": { "signatureEditorModal": { "labels": { "ok": "Ok", "signature": "Handtekening", "preview": "Voorbeeld", "editEmailSignature": "Handtekening e-mail bewerken", "save": "Opslaan", "visual": "Eenvoudig", "text": "HTML", "cancel": "Annuleren", "update": { "prompt": "Deze wijzigingen ook doorvoeren in mijn account-handtekening", "tooltip": "Laat dit vakje leeg om alleen de handtekening in de e-mail die je nu schrijft te updaten" }, "signatureSaved": "Je handtekening is opgeslagen." }, "descriptions": { "signature": "Je handtekening zal worden gebruikt in persoonlijke e-mails in de HubSpot CRM." }, "errors": { "title": "Er is iets misgegaan", "unableToLoadSignature": "Er is iets misgegaan bij het laden van je e-mailhandtekening. Probeer het opnieuw.", "unableToUpdateSignature": "Er is iets misgegaan bij het opslaan van je e-mailhandtekening. Probeer het opnieuw.", "signatureTooLong": "Je e-mailhandtekening is te lang en kan niet worden opgeslagen. Hij moet minder dan {{ maxLength }} tekens lang zijn. Probeer hem kleiner te maken." }, "unsupportedHTML": { "header": "Kan niet van modus wisselen", "description": "Je handtekening bevat enkele HTML-elementen die niet worden ondersteund door de eenvoudige editor. Gebruik de HTML-knop om je handtekening te bewerken met de onbewerkte HTML-editor.", "saveButtonDisabled": "Je handtekening bevat niet-ondersteunde HTML. Verwijder de volgende tags uit je handtekening:" }, "unsubscribeLink": { "link": "hier", "RELEVANT": "Is deze e-mail niet relevant voor jou? Klik dan {{ link }}", "STOP_GETTING_MESSAGES": "Klik {{ link }} om deze e-mails niet meer te ontvangen.", "PREFER_LESS": "Liever minder e-mails van mij? Klik dan {{ link }}", "edit": { "header": "Kies een link om af te melden", "submit": "Toepassen", "cancel": "Annuleren", "removeLink": "Link verwijderen" }, "info": { "header": "Waarom is dit hier?", "list": { "one": "Hubspot toont respect voor de afzender en de ontvanger door beide kanten de communicatie te laten beheren.", "two": "Dit is wettelijk noodzakelijk. {{ infoLink }} voor meer informatie." }, "infoLink": "Klik hier" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "nl": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:nl', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "no-no": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Signatur", "preview": "Forhåndsvisning", "editEmailSignature": "Rediger e-postsignatur", "save": "Lagre", "visual": "Enkel", "text": "HTML", "cancel": "Avbryt", "update": { "prompt": "Oppdater også kontosignaturen min med disse endringene", "tooltip": "La denne boksen være avmerket for å bare oppdatere signaturen i e-posten du skriver" }, "signatureSaved": "Signaturen er lagret." }, "descriptions": { "signature": "Signaturen vil bli brukt i én-til-én-e-poster gjennom HubSpot CRM." }, "errors": { "title": "Noe gikk galt", "unableToLoadSignature": "Det oppsto en feil da vi forsøkte å laste e-postsignaturen din. Prøv igjen.", "unableToUpdateSignature": "Det oppsto en feil da vi forsøkte å lagre e-postsignaturen din. Prøv igjen.", "signatureTooLong": "E-postsignaturen din er for lang og kan ikke lagres. Den må være under {{ maxLength }} tegn. Prøv å gjøre den kortere." }, "unsupportedHTML": { "header": "Kan ikke bytte moduser", "description": "Signaturen har noen HTML-elementer som ikke støttes i det enkle registreringsprogrammet. Bruk HTML-knappen til å redigere signaturen din med raw-HTML-redigeringsprogrammet.", "saveButtonDisabled": "Signaturen din har HTML som ikke støttes. Fjern følgende tagger fra signaturen:" }, "unsubscribeLink": { "link": "her", "RELEVANT": "Er denne e-posten irrelevant for deg? Klikk på {{ link }}", "STOP_GETTING_MESSAGES": "For å ikke motta disse e-postene, kan du klikke på {{ link }}", "PREFER_LESS": "Foretrekker du færre e-poster fra meg? Klikk på {{ link }}", "edit": { "header": "Velg en kobling for å  stoppe abonnement", "submit": "Bruk", "cancel": "Avbryt", "removeLink": "Fjern kobling" }, "info": { "header": "Hvorfor er dette her?", "list": { "one": "HubSpot respekterer avsenderen og mottakeren ved å tillate at begge sider administrerer kommunikasjonen.", "two": "Dette er lovpålagt. {{ infoLink }} for å lese mer." }, "infoLink": "Klikk her" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "no": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:no', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pl": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Podpis", "preview": "Podgląd", "editEmailSignature": "Edytuj podpis wiadomości e-mail", "save": "Zapisz", "visual": "Łatwe", "text": "HTML", "cancel": "Anuluj", "update": { "prompt": "Uaktualnij również mój podpis w ramach konta zgodnie z tymi zmianami", "tooltip": "Aby zmienić sygnaturę tylko w konkretnym e-mailu, pozostaw to pole odznaczone" }, "signatureSaved": "Twoja sygnatura została zapisana." }, "descriptions": { "signature": "Twoja sygnatura zostanie użyta w bezpośrednich e-mailach w obrębie HubSpot CRM." }, "errors": { "title": "Coś poszło nie tak", "unableToLoadSignature": "W trakcie ładowania sygnatury wiadomości e-mail wystąpił błąd. Spróbuj ponownie.", "unableToUpdateSignature": "W trakcie zapisywania sygnatury wiadomości e-mail wystąpił błąd. Spróbuj ponownie.", "signatureTooLong": "Sygnatura wiadomości e-mail jest za długa i nie może zostać zapisana. Musi mieć mniej niż {{ maxLength }} znaków. Postaraj się ją skrócić." }, "unsupportedHTML": { "header": "Nie można przełączyć trybu", "description": "Podpis zawiera elementy HTML nieobsługiwane przez prosty edytor. Użyj przycisku HTML, aby edytować podpis za pomocą podstawowego edytora HTML.", "saveButtonDisabled": "Twój podpis ma nieobsługiwany HTML. Usuń którykolwiek z poniższych tagów z podpisu:" }, "unsubscribeLink": { "link": "tutaj", "RELEVANT": "Czy ten e-mail nie jest skierowany do Ciebie? Kliknij {{ link }}", "STOP_GETTING_MESSAGES": "Aby nie otrzymywać więcej tych wiadomości, kliknij {{ link }}", "PREFER_LESS": "Wolisz otrzymywać ode mnie mniej wiadomości? Kliknij {{ link }}", "edit": { "header": "Kliknij łącze anulowania subskrypcji", "submit": "Zastosuj", "cancel": "Anuluj", "removeLink": "Usuń łącze" }, "info": { "header": "Dlaczego to się tutaj znalazło?", "list": { "one": "HubSpot szanuje zarówno nadawcę, jak i odbiorcę, umożliwiając obu stronom zarządzanie konwersacją. ", "two": "Jest to wymagane przepisami prawa. Kliknij {{ infoLink }}, aby dowiedzieć się więcej." }, "infoLink": "Kliknij tutaj" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "pl": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:pl', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Assinatura", "preview": "Visualizar", "editEmailSignature": "Editar assinatura de email", "save": "Salvar", "visual": "Simples", "text": "HTML", "cancel": "Cancelar", "update": { "prompt": "Atualize também a assinatura da minha conta com essas alterações", "tooltip": "Deixe esta caixa desmarcada para atualizar apenas a assinatura no email que você está redigindo" }, "signatureSaved": "Sua assinatura foi salva." }, "descriptions": { "signature": "Sua assinatura será usada em emails individuais em todo o HubSpot CRM." }, "errors": { "title": "Algo deu errado", "unableToLoadSignature": "Ocorreu um erro ao tentar carregar sua assinatura de e-mail. Tente novamente.", "unableToUpdateSignature": "Ocorreu um erro ao tentar salvar sua assinatura de e-mail. Tente novamente.", "signatureTooLong": "Sua assinatura de e-mail é muito longa e não pode ser salva. Ela deve ter menos que {{ maxLength }} caracteres. Tente diminuí-la." }, "unsupportedHTML": { "header": "Não é possível trocar de modo", "description": "Sua assinatura tem alguns elementos HTML que não são compatíveis com o editor simples. Use o botão HTML para editar sua assinatura com o editor HTML bruto.", "saveButtonDisabled": "Sua assinatura tem HTML não compatível. Remova qualquer uma das seguintes tags da sua assinatura:" }, "unsubscribeLink": { "link": "aqui", "RELEVANT": "Esse email não é relevante para você? Clique {{ link }}", "STOP_GETTING_MESSAGES": "Para parar de receber esses emails, clique {{ link }}", "PREFER_LESS": "Prefere receber menos emails de mim? Clique em {{ link }}", "edit": { "header": "Escolha um link de cancelamento de assinatura", "submit": "Aplicar", "cancel": "Cancelar", "removeLink": "Remover link" }, "info": { "header": "Por que isso está aqui?", "list": { "one": "O HubSpot respeita o remetente e o destinatário, permitindo que ambos os lados gerenciem as comunicações.", "two": "Isso é juridicamente necessário. {{ infoLink }} para ler mais." }, "infoLink": "Clique aqui" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "pt-br": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:pt-br', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sv": { "signatureEditorModal": { "labels": { "ok": "OK", "signature": "Signatur", "preview": "Förhandsgranskning", "editEmailSignature": "Redigera e-postsignatur", "save": "Spara", "visual": "Enkel", "text": "HTML", "cancel": "Avbryt", "update": { "prompt": "Uppdatera även min kontosignatur med dessa ändringar", "tooltip": "Lämna denna kryssruta omarkerad om du endast vill uppdatera signaturen i det e-postmeddelande som du skriver" }, "signatureSaved": "Signaturen har sparats." }, "descriptions": { "signature": "Din signatur används i direktadresserade e-postmeddelanden via HubSpot CRM." }, "errors": { "title": "Ett fel har uppstått", "unableToLoadSignature": "Ett fel uppstod när din e-postsignatur skulle laddas. Försök igen.", "unableToUpdateSignature": "Ett fel uppstod när din e-postsignatur skulle sparas. Försök igen.", "signatureTooLong": "Din e-postsignatur är för lång och kan inte sparas. Den måste vara kortare än {{ maxLength }} tecken. Försök att göra den kortare." }, "unsupportedHTML": { "header": "Det går inte att byta läge", "description": "Din signatur innehåller HTML-element som inte stöds av det enkla redigeringsprogrammet. Klicka på HTML-knappen för att redigera signaturen med redigeringsprogrammet för rå HTML.", "saveButtonDisabled": "Din signatur har HTML som inte stöds. Ta bort någon av följande taggar från din signatur:" }, "unsubscribeLink": { "link": "här", "RELEVANT": "Är e-postmeddelandet irrelevant? Klicka {{ link }}", "STOP_GETTING_MESSAGES": "Om du vill stoppa e-postutskick av den här typen ska du klicka {{ link }}", "PREFER_LESS": "Vill du få färre e-postmeddelanden från mig? Klicka {{ link }}", "edit": { "header": "Välj en länk för uppsägning av prenumeration", "submit": "Använd", "cancel": "Avbryt", "removeLink": "Ta bort länk" }, "info": { "header": "Varför är detta med?", "list": { "one": "HubSpot värnar om såväl avsändaren som mottagaren och gör det möjligt för båda parter att hantera kommunikationen.", "two": "Det här är ett lagkrav. {{ infoLink }} för att läsa mer." }, "infoLink": "Klicka här" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "sv": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:sv', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "signatureEditorModal": { "labels": { "ok": "确定", "signature": "签名", "preview": "预览", "editEmailSignature": "编辑电邮签名", "save": "保存", "visual": "简单", "text": "HTML", "cancel": "取消", "update": { "prompt": "同时使用这些更改更新我的帐户签名", "tooltip": "如果不选中此框，系统将只会更新您正在撰写的电邮中的签名" }, "signatureSaved": "签名已保存。" }, "descriptions": { "signature": "您的签名将用于 HubSpot CRM 的所有一对一电邮。" }, "errors": { "title": "出错了", "unableToLoadSignature": "尝试加载您的电邮签名时出错。请重试。", "unableToUpdateSignature": "尝试保存您的电邮签名时出错。请重试。", "signatureTooLong": "您的电邮签名太长，因此无法保存。电邮长度不得超过 {{ maxLength }} 个字符。请尝试缩短电邮签名。" }, "unsupportedHTML": { "header": "无法切换模式", "description": "您的签名中包含一些简单编辑器不支持的 HTML 元素。请点击 HTML 按钮，使用原始 HTML 编辑器来编辑签名。", "saveButtonDisabled": "您的签名中包含不受支持的 HTML 元素。请从您的签名中删除以下所有标签：" }, "unsubscribeLink": { "link": "此处", "RELEVANT": "此电邮与您无关？请点击{{ link }}", "STOP_GETTING_MESSAGES": "要停止接收这些电邮，请点击{{ link }}", "PREFER_LESS": "觉得我发送的电邮过多，不想收到这么多电邮？请点击{{ link }}", "edit": { "header": "选择退订链接", "submit": "应用", "cancel": "取消", "removeLink": "移除链接" }, "info": { "header": "这里为什么有退订链接？", "list": { "one": "HubSpot 允许收件人和发件人管理彼此的通信，以示对双方的尊重。", "two": "这是一项法律强制要求。{{ infoLink }}了解更多。" }, "infoLink": "点击此处" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "zh-cn": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:zh-cn', {version: 'static-1.3760'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "signatureEditorModal": { "labels": { "ok": "確認", "signature": "簽名", "preview": "預覽", "editEmailSignature": "編輯電郵簽名", "save": "儲存", "visual": "簡單", "text": "HTML", "cancel": "取消", "update": { "prompt": "同時用這些更改更新我的帳戶簽名", "tooltip": "不核取此方塊，則只更新你正在撰寫電郵的簽名" }, "signatureSaved": "已儲存你的簽名。" }, "descriptions": { "signature": "你的簽名會用於 HubSpot CRM 中所有一對一電郵。" }, "errors": { "title": "發生錯誤", "unableToLoadSignature": "嘗試載入你的電郵簽名時發生錯誤，請再試一次。", "unableToUpdateSignature": "嘗試儲存你的電郵簽名時發生錯誤，請再試一次。", "signatureTooLong": "你的電郵簽名太長而無法儲存，簽名必須少於 {{ maxLength }} 個字元，請修改為更短。" }, "unsupportedHTML": { "header": "無法切換模式", "description": "簡單編輯器不支援你簽名中的 HTML 元素。請使用 HTML 按鈕，以原始 HTML 編輯器編輯你的簽名。", "saveButtonDisabled": "你的簽名有不支援的 HTML 元素。請從簽名移除下列任何一個標籤：" }, "unsubscribeLink": { "link": "此處", "RELEVANT": "此電郵與你無關？請按{{ link }}", "STOP_GETTING_MESSAGES": "若要停止接收這些電郵，請按{{ link }}", "PREFER_LESS": "希望較少收到我的電郵？請按{{ link }}", "edit": { "header": "選擇取消訂閱連結", "submit": "套用", "cancel": "取消", "removeLink": "移除連結" }, "info": { "header": "這為何會出現？", "list": { "one": "HubSpot 容許寄件者和收件者管理通訊，尊重雙方。", "two": "法律規定此為必須。{{ infoLink }}了解詳情。 " }, "infoLink": "請按此處" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "zh-hk": "static-1.3760"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.3760",
    "da": "static-1.3760",
    "de": "static-1.3760",
    "el": "static-1.3760",
    "en": "static-1.3760",
    "es-mx": "static-1.3760",
    "es": "static-1.3760",
    "fi": "static-1.3760",
    "fr": "static-1.3760",
    "it": "static-1.3760",
    "ja": "static-1.3760",
    "ko": "static-1.3760",
    "nl": "static-1.3760",
    "no": "static-1.3760",
    "pl": "static-1.3760",
    "pt-br": "static-1.3760",
    "sv": "static-1.3760",
    "zh-cn": "static-1.3760",
    "zh-hk": "static-1.3760"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:zh-hk', {version: 'static-1.3760'}); }
})();























/* global hubspot: false */
// eslint-disable-next-line prefer-arrow-callback
hubspot.define('underscore', ['_'], function(_) {
  return _;
});


